__THEME_GLOBALS__.changeBtnState = function (btn, state, btnInner) {
  if (!btn) return
  state === 'active'
    ? btn.removeAttribute('disabled')
    : btn.setAttribute('disabled', 'disabled')
  if (btnInner) btn.innerHTML = btnInner
}

__THEME_GLOBALS__.isHidden = function (el) {
  const style = window.getComputedStyle(el)
  return style?.display === 'none' || style?.visibility === 'hidden'
}

__THEME_GLOBALS__.setAttributes = function (el, attrObj) {
  Object.keys(attrObj).forEach((key) => el.setAttribute(key, attrObj[key]))
}

__THEME_GLOBALS__.addScripts = function (scriptObj) {
  return Promise.all(
    Object.keys(scriptObj).map((key) => {
      return new Promise((resolve) => {
        const script = document.createElement('script')
        script.type = 'text/javascript'
        script.src = scriptObj[key]
        document.getElementsByTagName('body')[0].appendChild(script)
        script.addEventListener('load', () => resolve())
      })
    })
  )
}

__THEME_GLOBALS__.serializeObject = function (form) {
  const formData = new FormData(form)
  const bodyObj = {}
  for (const [name, value] of formData) bodyObj[name] = value
  return bodyObj
}

__THEME_GLOBALS__.pdpErrorMessage = function (error) {
  if (error.status === 422) {
    const errorMessage = document.querySelector('.PdpErrorMessage')
    errorMessage.innerHTML = error.responseJSON.description
    errorMessage.style.display = 'block'
    setTimeout(() => {
      errorMessage.style.display = 'none'
      errorMessage.innerHTML = ''
    }, 3500)
  }
}

__THEME_GLOBALS__.disableScroll = function () {
  document.body.style.overflow = 'hidden'
}

__THEME_GLOBALS__.enableScroll = function () {
  document.body.style.removeProperty('overflow')
}

__THEME_GLOBALS__.handleize = function (str) {
  return str
    .toLowerCase()
    .replace(/[^\w\u00C0-\u024f]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

__THEME_GLOBALS__.toggleSlickVideoPlay = function (slider, videoSlides) {
  function togglePlay(firstLoad) {
    videoSlides.each((i, video) => {
      if ($(video).parents('.slick-slide').hasClass('slick-active')) {
        video.play()
      } else if (firstLoad) {
        setTimeout(() => video.pause(), 500)
      } else {
        video.pause()
      }
    })
  }
  togglePlay(true)

  slider.on('afterChange', (event, slick, currentSlide) => {
    togglePlay(false)
  })
}

__THEME_GLOBALS__.toggleSlickArrows = function (slider, prevArrow, nextArrow) {
  slider.on('afterChange', (event, slick, currentSlide) => {
    currentSlide === 0
      ? prevArrow.addClass('is-hidden')
      : prevArrow.removeClass('is-hidden')
    currentSlide === slick.slideCount - 1
      ? nextArrow.addClass('is-hidden')
      : nextArrow.removeClass('is-hidden')
  })
}

__THEME_GLOBALS__.slickSlider = function () {
  $('[data-section-type="slick-slideshow"]').each(function () {
    const $slider = $(this).find('.jsSlickSlider')
    let config = null

    if ($(this).attr('data-slick-config')) {
      config = $.parseJSON($(this).attr('data-slick-config'))
      if (config) {
        if (config['arrows']) {
          config.prevArrow = $(this).find('.jsPrevSlide')
          config.nextArrow = $(this).find('.jsNextSlide')
        }
      }
    }

    if ($slider.length) $slider.not('.slick-initialized').slick(config)

    if ($slider[0] && $slider[0].hasAttribute('data-toggle-arrows')) {
      const prevArrow = $slider.find('.jsPrevSlide')
      const nextArrow = $slider.find('.jsNextSlide')
      if ($(prevArrow).length && $(nextArrow).length) {
        __THEME_GLOBALS__.toggleSlickArrows($slider, $(prevArrow), $(nextArrow))
      }
    }

    const videoSlides = $slider.find('video')
    if (videoSlides.length)
      __THEME_GLOBALS__.toggleSlickVideoPlay($slider, videoSlides)
  })
}

__THEME_GLOBALS__.slickSlider()

__THEME_GLOBALS__.checkSlickResponse = function (
  selector,
  config,
  response,
  maxMedia
) {
  if (!$(selector).length) return

  function checkSlider() {
    const videoSlides = $(selector).find('video')
    const condition = maxMedia
      ? $(window).width() < response
      : $(window).width() > response
    if (condition) {
      const prevArrow = $(selector).parent().find('.jsPrevSlide')
      const nextArrow = $(selector).parent().find('.jsNextSlide')
      if (config['arrows']) {
        if (prevArrow.length) config.prevArrow = prevArrow
        if (nextArrow.length) config.nextArrow = nextArrow
      }
      $(selector).not('.slick-initialized').slick(config)

      if (
        $(selector)[0].hasAttribute('data-toggle-arrows') &&
        $(prevArrow).length &&
        $(prevArrow).length
      ) {
        __THEME_GLOBALS__.toggleSlickArrows(
          $(selector),
          $(prevArrow),
          $(nextArrow)
        )
      }

      if (videoSlides.length)
        __THEME_GLOBALS__.toggleSlickVideoPlay($(selector), videoSlides)
    } else {
      if ($(selector).hasClass('slick-initialized')) {
        $(selector).slick('unslick')
        if (videoSlides.length) videoSlides.each((i, video) => video.play())
      }
    }
  }

  checkSlider()
  $(window).resize(function () {
    checkSlider()
  })
}

__THEME_GLOBALS__.checkAllSlidersResponse = function () {
  const allResponseSliders = document.querySelectorAll(
    '[data-check-slick-response]'
  )
  allResponseSliders.forEach((slider) => {
    const sliderAttr = slider.getAttribute('data-check-slick-response')
    if (!sliderAttr) return
    const settings = JSON.parse(sliderAttr)
    __THEME_GLOBALS__.checkSlickResponse(
      settings.selector,
      settings.config,
      settings.response,
      settings.maxMedia
    )
  })
}

__THEME_GLOBALS__.checkAllSlidersResponse()

__THEME_GLOBALS__.mutation = function updateProductColors(
  $targetNode,
  callback
) {
  const config = { attributes: true, childList: true, subtree: true },
    observer = new MutationObserver(callback)
  observer.observe($targetNode, config)
}

__THEME_GLOBALS__.formatMoney = function (cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '')
  }

  const defaultTo = function (value, defaultValue) {
    return value == null || value !== value ? defaultValue : value
  }

  let value = ''
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
  const formatString = format || __THEME_GLOBALS__.moneyFormat

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2)
    thousands = defaultTo(thousands, ',')
    decimal = defaultTo(decimal, '.')

    if (isNaN(number) || number == null) {
      return 0
    }

    number = (number / 100.0).toFixed(precision)

    const parts = number.split('.')
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      '$1' + thousands
    )
    const centsAmount = decimal + parts[1]

    return dollarsAmount + centsAmount
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2)
      break
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0)
      break
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',')
      break
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',')
      break
  }

  return formatString.replace(placeholderRegex, value)
}

__THEME_GLOBALS__.headerHeight = function () {
  document.documentElement.style.setProperty(
    '--header-height',
    document.getElementById('MainHeader').offsetHeight + 'px'
  )
}

__THEME_GLOBALS__.stickyHeight = function () {
  if (document.querySelector('.js-sticky-cta'))
    document.documentElement.style.setProperty(
      '--custom-main-offset',
      document.querySelector('.js-sticky-cta').offsetHeight + 'px'
    )
}

__THEME_GLOBALS__.slideUp = function (target, duration = 500) {
  target.classList.remove('active')
  target.style.display = 'block'
  target.style.transitionProperty = 'height, margin, padding'
  target.style.transitionDuration = duration + 'ms'
  target.style.boxSizing = 'border-box'
  target.style.height = target.offsetHeight + 'px'
  target.offsetHeight
  target.style.overflow = 'hidden'
  target.style.height = 0
  target.style.paddingTop = 0
  target.style.paddingBottom = 0
  target.style.marginTop = 0
  target.style.marginBottom = 0
  window.setTimeout(() => {
    target.style.display = 'none'
    target.style.removeProperty('height')
    target.style.removeProperty('padding-top')
    target.style.removeProperty('padding-bottom')
    target.style.removeProperty('margin-top')
    target.style.removeProperty('margin-bottom')
    target.style.removeProperty('overflow')
    target.style.removeProperty('transition-duration')
    target.style.removeProperty('transition-property')
  }, duration)
}

__THEME_GLOBALS__.slideDown = function (target, duration = 500) {
  target.classList.add('active')
  target.style.removeProperty('display')
  let display = window.getComputedStyle(target).display
  if (display === 'none') display = 'block'
  target.style.display = display
  let height = target.offsetHeight
  target.style.overflow = 'hidden'
  target.style.height = 0
  target.style.paddingTop = 0
  target.style.paddingBottom = 0
  target.style.marginTop = 0
  target.style.marginBottom = 0
  target.offsetHeight
  target.style.boxSizing = 'border-box'
  target.style.transitionProperty = 'height, margin, padding'
  target.style.transitionDuration = duration + 'ms'
  target.style.height = height + 'px'
  target.style.removeProperty('padding-top')
  target.style.removeProperty('padding-bottom')
  target.style.removeProperty('margin-top')
  target.style.removeProperty('margin-bottom')
  window.setTimeout(() => {
    target.style.removeProperty('height')
    target.style.removeProperty('overflow')
    target.style.removeProperty('transition-duration')
    target.style.removeProperty('transition-property')
  }, duration)
}

__THEME_GLOBALS__.slideToggle = function (target, duration = 250) {
  if (!target.classList.contains('active')) {
    return __THEME_GLOBALS__.slideDown(target, duration)
  } else {
    return __THEME_GLOBALS__.slideUp(target, duration)
  }
}

__THEME_GLOBALS__.objToStrUrlEncode = function (obj) {
  const str = []
  for (var key in obj) {
    if (obj.hasOwnProperty(key) && typeof obj[key] !== 'undefined') {
      str.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
    }
  }
  return str.join('&')
}

__THEME_GLOBALS__.klaviyoTrigger = function (form, listID = '') {
  const email = form.querySelector('input[type=email]')
  const phone = form.querySelector('input[type=tel]')

  const data = {
    g: listID,
    $fields: '$source,$email,$phone,$consent_method',
    $list_fields: '',
    $timezone_offset: Math.abs(new Date().getTimezoneOffset() / 60),
    $source: form.id ? form.id : 'Shopify',
    $email: email ? email.value : '',
    $phone_number: phone ? phone.value : '',
    $consent_method: 'Klaviyo Form',
    $origin: 'origin',
  }

  return fetch('https://a.klaviyo.com/ajax/subscriptions/subscribe', {
    headers: {
      accept: '*/*',
      'accept-language': 'en-US,en;q=0.9',
      'content-type': 'application/x-www-form-urlencoded',
    },
    body: __THEME_GLOBALS__.objToStrUrlEncode(data),
    method: 'POST',
    mode: 'cors',
    credentials: 'omit',
  })
    .then((response) => response.json())
    .then((response) => {
      console.log(response)
    })
    .catch((err) => {
      console.error(err)
    })
}

__THEME_GLOBALS__.collectionAndSearch = function (isSearchPage) {
  if ($('.collectionFilters').length) {
    if ($('[data-dropdown-filter]').length) {
      $(document).on(
        'keypress.dropdownFilters click.dropdownFilters',
        '[data-dropdown-filter]',
        function () {
          console.log('afskbgasjfh')
          if (window.innerWidth > 992) {
            let $dropdownList = $(this).parent().find('[data-dropdown-list]')
            if ($dropdownList.length) {
              $(this).parent().find('[data-dropdown-list]').slideToggle(400)
              $(this)
                .find('.dropdownHeader-icon')
                .toggleClass('dropdownHeader-icon--rotate')
              $(this)
                .parent()
                .find('.dropdownContent--animate-block')
                .toggleClass('dropdownContent--animate-block-visible')
            }
          }
        }
      )

      $(window).on('resize.filter', function () {
        if (window.innerWidth < 992) {
          $('[data-dropdown-list]').map(function (i, element) {
            $(element)
              .parent()
              .find('.dropdownHeader-icon')
              .removeClass('dropdownHeader-icon--rotate')
            $(element)
              .find('.dropdownContent--animate-block-visible')
              .removeClass('dropdownContent--animate-block-visible')
            $(element).removeAttr('style')
          })
        } else {
          $('[data-mobile-dropdown]').removeAttr('style')
        }
      })
    }

    $(document).on(
      'click.mobileFilterBar',
      '[data-mobile-filter]',
      function () {
        let $targetFilter = $(
          '[data-mobile-dropdown="' + $(this).data('mobile-filter') + '"]'
        )
        $(this).toggleClass('open-filter')
        $(
          '[data-mobile-filter]:not([data-mobile-filter="' +
            $(this).data('mobile-filter') +
            '"])'
        ).removeClass('open-filter')
        $(
          '[data-mobile-dropdown]:not([data-mobile-dropdown="' +
            $(this).data('mobile-filter') +
            '"])'
        ).slideUp(400)
        $targetFilter.slideToggle(400)
      }
    )

    function filterResults() {
      let $filterForm = $(document).find('#filter-form'),
        $collectionProducts = $(document).find('.collection__products-results'),
        $filterFormInput = $filterForm.find('input'),
        $filterPriceRange = $filterForm.find(
          '.filter-group__price-range-to input'
        ),
        $filterPriceMin = $filterForm.find(
          '.filter-group__price-range-min-value'
        ),
        formData = $filterForm.serialize(),
        url =
          window.location.protocol +
          '//' +
          window.location.host +
          window.location.pathname +
          '?view=ajax&' +
          formData,
        $noResultsMessage = `<h3 class="collection__products-no-results">No results</h3>`

      if (isSearchPage) {
        var urlSearchParams = new URLSearchParams(window.location.search)
        var params = Object.fromEntries(urlSearchParams.entries())
        var queryKey = params.q

        if (queryKey.length) {
          url =
            window.location.protocol +
            '//' +
            window.location.host +
            window.location.pathname +
            '?q=' +
            queryKey +
            '&options%5Bprefix%5D=last&resources[options][unavailable_products]=hide&' +
            formData
        }
      }

      $filterFormInput.attr('disabled', 'true')

      $.ajax({
        url: url,
        method: 'GET',
        success: function (data) {
          let $collectionNewProducts = $(data).find(
              '.collection__products-results'
            ),
            $filterNewPriceMin = $(data)
              .find('.filter-group__price-range-min-value')
              .html()
          $collectionNewProducts.find('hh-product-card').length
            ? $collectionProducts.html($collectionNewProducts.html())
            : $collectionProducts.html($noResultsMessage)
          $filterPriceRange.prop({
            min: $filterNewPriceMin.trim(),
          })
          $filterPriceMin.html($filterNewPriceMin)
          $filterFormInput.removeAttr('disabled')
        },
      })
    }

    $(document).on(
      'click.deleteFilterResult',
      '.filter-result-close',
      function () {
        $(
          '[data-filter-type="' +
            $(this).parent().attr('data-result-type') +
            '"]'
        ).removeAttr('checked')
        $(this).parent().remove()
      }
    )

    $(document).on('change.inputFilters', '#filter-form input', function () {
      filterResults()
      $(this)
        .parents('ul')
        .find('.filter-group__list-item')
        .removeClass('active-input')
      $(this).parents('.filter-group__list-item').addClass('active-input')

      if ($('.filter-group-custom input:checked').length) {
        $('[data-mobile-filter="custom"] span').html(
          `<span class="filter-counter">(${
            $('.filter-group-custom input:checked').length
          })</span>`
        )
      } else {
        $('[data-mobile-filter="custom"] span').html('')
      }

      let $filterPriceRange = $(document).find(
          '.filter-group__price-range-to input'
        ),
        $filterPriceMax = $(document).find(
          '.filter-group__price-range-max-value'
        ),
        checkedInputs = $(document).find('#filter-form input:checked').length,
        rangeValueChanged =
          parseInt($filterPriceRange.attr('max')) !==
          parseInt($filterPriceMax.text())
      checkedInputs || rangeValueChanged
        ? $('[data-clear-filter]').show()
        : $('[data-clear-filter]').hide()
    })

    $(document).on(
      'input.changeRange',
      '#filter-form input[type="range"]',
      function () {
        let $filterPriceMax = $(document).find(
          '.filter-group__price-range-max-value'
        )
        $filterPriceMax.html($(this).val() + '.00')
      }
    )

    $(document).on('click.mobileClearAll', '[data-clear-filter]', function () {
      let $collectionContainer = $(document).find('.collectionContainer')
      let url = $(this).data('clear-filter')
      if (isSearchPage) {
        url = window.location.href
      }

      $.ajax({
        url: url,
        method: 'GET',
        success: function (data) {
          let $collectionNewContainer = $(data)
            .find('.collectionContainer')
            .html()
          $collectionContainer.html($collectionNewContainer)
        },
      })
    })
  }
}

__THEME_GLOBALS__.searchBar = function () {
  var $searchBar = $('.headerSearch'),
    $searchInput = $('.headerSearch__input'),
    $searchBarToggle = $('[data-action="toggle-search"]'),
    $searchResultWrapper = $('.headerSearch__results'),
    $popularSearches = $('.headerSearch__popularSearches'),
    $searchResultContent = $('.headerSearch__resultsContent'),
    $searchPopular = $searchBar.find('.search__popular'),
    $searchEmpty = $('.headerSearch__emptyResults'),
    $resultsWrapper = $('.headerSearch__resultsHeader'),
    $resetBtn = $('.headerSearch__resetLabel')

  // function toggleSearch () {
  //   if ($searchBar.attr('aria-hidden') === 'false') {
  //     __THEME_GLOBALS__.closeSearch();
  //   } else {
  //     openSearch();
  //   }
  // }

  __THEME_GLOBALS__.closeSearch = function () {
    $searchBar.attr('aria-hidden', 'true')
    $searchBar.slideUp(0)
    $searchBarToggle.attr('aria-expanded', 'false')
    $searchBar.removeClass('loading')
  }

  // function openSearch () {
  //   $searchBar.attr('aria-hidden', 'false');
  //   $searchBar.slideDown(200);
  //   $searchBarToggle.attr('aria-expanded', 'true');
  //   inputFocus();
  // }

  function inputFocus() {
    setTimeout(function () {
      $searchBar.find('.headerSearch__input').focus()
    }, 100)
  }

  function hidePopularSearch() {
    $popularSearches.hide()
    $searchEmpty.hide()
    $resultsWrapper.show()
    $searchPopular.hide()
  }

  function showPopularSearch() {
    $searchPopular.show()
    $popularSearches.show()
    $resultsWrapper.hide()
    $searchEmpty.show()
  }

  function onInput(event) {
    var _this = $(event.target),
      value = _this.val().trim(),
      queryKey = value.toLowerCase(),
      queryKeyReplace = queryKey.replace(/ /gi, '-')

    $searchBar.addClass('loading')
    $searchResultWrapper.attr('aria-hidden', 'false')
    $searchResultContent.empty()

    if (queryKey.length) {
      $resetBtn.show()
      $searchPopular.hide()

      fetch(`/search/suggest.json?q=${queryKey}&resources[type]=product`)
        .then((response) => response.json())
        .then((suggestions) => {
          const productSuggestions = suggestions.resources.results.products
          let hiddenItems = 0
          if (productSuggestions.length > 0) {
            productSuggestions.forEach(function (product) {
              if (product.type !== 'Gift product') {
                const productTags = product.tags
                let noSearchTags = []

                // Make array no search terms
                $.each(productTags, function (index, value) {
                  const nosearchTag = value
                    .toLowerCase()
                    .replace(/ /gi, '-')
                    .split('nosearch-')[1]
                  if (nosearchTag) noSearchTags.push(nosearchTag)
                })

                if (!noSearchTags.includes(queryKeyReplace)) {
                  var productItem = `<li class="headerSearch__item"><a href="${product.url}">${product.title}</a></li>`
                  $searchResultContent.append(productItem)
                } else {
                  ++hiddenItems
                }
              }
            })

            if (hiddenItems === productSuggestions.length) {
              showPopularSearch()
            } else {
              hidePopularSearch()
            }
          } else {
            showPopularSearch()
          }

          $searchBar.removeClass('loading')
        })
        .catch((error) => {
          __THEME_GLOBALS__.closeSearch()
          $searchBar.removeClass('loading')
          $searchResultWrapper.attr('aria-hidden', 'true')
        })
    } else {
      $searchBar.removeClass('loading')
      $popularSearches.show()
      $resetBtn.hide()
      $searchPopular.show()
    }
  }

  $(document).on(
    'submit.headerSearchForm',
    '.headerSearch__form',
    function (event) {
      event.preventDefault()
      var value = $searchInput.val().trim(),
        queryKey = value.toLowerCase()

      var urlToRedirect =
        '/search?q=' + queryKey + '&options%5Bprefix%5D=last&type=product'
      window.location.href = urlToRedirect
    }
  )

  // $(document).on('click.searchBarToggle', '.mobileMenu__link[data-action="toggle-search"]', function (event) {
  //   event.preventDefault();
  //   toggleSearch();
  // });

  // $(document).on('mouseover.searchBarOpen', '#search-bar-button[data-action="toggle-search"]', function (event) {
  //   event.preventDefault();
  //   openSearch();
  //   $('.newHeader__openedBlock[aria-hidden="false"]').slideUp();
  //   $('.newHeader__openedBlock[aria-hidden="false"]').attr('aria-hidden', 'true');
  //   $('.newHeader__link[data-selected="true"]').attr('data-selected', 'false');
  // });

  $(document).on(
    'input.onInput',
    '.headerSearch__input[type="search"]',
    $.debounce(250, function (event) {
      onInput(event)
    })
  )

  $(document).on(
    'click.resetSearch',
    '.headerSearch__resetLabel, #header-search-reset',
    function () {
      $searchResultWrapper.attr('aria-hidden', 'true')
      $popularSearches.show()
      $searchResultContent.empty()
      $searchPopular.show()
      $resetBtn.hide()
      $searchEmpty.hide()
      $resultsWrapper.show()
      inputFocus()
    }
  )

  // $(document).on('mousedown.searchBarClose', function (e) {
  //   if (!$searchBar.is(e.target) && $searchBar.has(e.target).length === 0 && $searchBarToggle.has(e.target).length === 0) {
  //     __THEME_GLOBALS__.closeSearch();
  //   }
  // })
}

__THEME_GLOBALS__.searchPage = function () {
  var $searchInput = $('.searchForm__inputMain')
  var $searchInputReset = $('.searchForm__mainResetLabel')

  function changeDocumentTitle() {
    var resultCount = $(document)
      .find('[data-result-count]')
      .attr('data-result-count')
    var searchTerms = $(document).find('[data-terms]').attr('data-terms')
    document.title = `Search: ${resultCount} results found for "${searchTerms}" – Fellow`
  }
  changeDocumentTitle()

  function getUrlRequest() {
    var value = $searchInput.val().trim()
    var queryKey = value.toLowerCase()
    var url = '/search?q=' + queryKey + '&options%5Bprefix%5D=last&type=product'

    window.location.href = url
  }

  $(document).on(
    'click.resetMainSearchInput',
    '.searchForm__mainResetLabel, #search-reset',
    function () {
      $searchInput.removeAttr('value')
      $(this).hide()
      getUrlRequest()
    }
  )

  $(document).on(
    'input.onInputMain',
    '.searchForm__inputMain[type="search"]',
    $.debounce(250, function () {
      var value = $(this).val().trim(),
        queryKey = value.replace(' ', '-').toLowerCase()

      queryKey.length ? $searchInputReset.show() : $searchInputReset.hide()
    })
  )

  $(document).on('submit.mainSearchForm', '.searchFormMain', function (event) {
    event.preventDefault()
    getUrlRequest()
  })
}

document.addEventListener('DOMContentLoaded', () => {
  if ($('.collection').length || $('.searchMain').length) {
    if ($('.searchMain').length) {
      var isSearchPage = true
    }
    __THEME_GLOBALS__.collectionAndSearch(isSearchPage)
  }

  if ($('.headerSearch').length) __THEME_GLOBALS__.searchBar()

  if ($('.searchMain').length) __THEME_GLOBALS__.searchPage()

  if ($('form[action^="htpps://www.facebook.com"]').length) {
    $('form[action^="htpps://www.facebook.com"]').attr('aria-hidden', 'true')
  }

  __THEME_GLOBALS__.headerHeight()
  window.addEventListener('resize', __THEME_GLOBALS__.headerHeight)

  __THEME_GLOBALS__.stickyHeight()
  window.addEventListener('resize', __THEME_GLOBALS__.stickyHeight)
})

class dynamicRecommendations extends HTMLElement {
  constructor() {
    super()
    this.productId = this.getAttribute('data-product-id')
    this.limit = this.getAttribute('data-product-limit')
    this.sectionId = this.getAttribute('data-section-id')
    this.recommendationContainer = this.querySelector('[data-product-row]')
    this.recommendUrl = `${window.location.origin}/recommendations/products?product_id=${this.productId}&limit=${this.limit}&section_id=${this.sectionId}`
    this.loadRecommendations()
  }

  loadRecommendations() {
    fetch(this.recommendUrl)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html'),
          recommendedContent = html.querySelector('[data-product-row]')
        if (recommendedContent) {
          this.recommendationContainer.innerHTML = recommendedContent.innerHTML
        }
        // Half Helix update: rehydrate swatches in product cards after server-side render
        const cards =
          this.recommendationContainer.querySelectorAll('hh-product-card')
        for (const card of cards) {
          const swatchValuesTemplate =
            this.recommendationContainer.querySelector(
              `#swatch-values-json-${card.id}`
            )
          const variantsTemplate = this.recommendationContainer.querySelector(
            `#variants-json-${card.id}`
          )
          const swatchValues = swatchValuesTemplate
            ? JSON.parse(swatchValuesTemplate.content.textContent.trim())
            : []
          const variants = variantsTemplate
            ? JSON.parse(variantsTemplate.content.textContent.trim())
            : []
          card.swatches = swatchValues
          card.variants = variants
        }
      })
  }
}

customElements.define('dynamic-recommendations', dynamicRecommendations)

class quantityStepper extends HTMLElement {
  constructor() {
    super()
    this.singleStepper = this.getAttribute('data-single-stepper')
    this.quantityInput = this.querySelector('.js-quantity')
    this.minusBtn = this.querySelector('.js-minus')
    this.plusBtn = this.querySelector('.js-plus')

    if (this.minusBtn)
      this.minusBtn.addEventListener('click', () =>
        this.quantityStepper('minus')
      )
    if (this.plusBtn)
      this.plusBtn.addEventListener('click', () => this.quantityStepper('plus'))
    if (this.quantityInput)
      this.quantityInput.addEventListener('change', () => this.quantityCheck())
  }

  quantityStepper(action) {
    this.quantityInput.value =
      action === 'minus'
        ? Number(this.quantityInput.value) - 1
        : Number(this.quantityInput.value) + 1
    if (this.singleStepper === 'true') this.quantitySingle()
    const evt = new Event('change')
    this.quantityInput.dispatchEvent(evt)
  }

  quantitySingle() {
    __THEME_GLOBALS__.changeBtnState(this.minusBtn, 'disabled')
    __THEME_GLOBALS__.changeBtnState(this.plusBtn, 'disabled')
  }

  quantityCheck() {
    const min = Number(this.quantityInput.min),
      max = Number(this.quantityInput.max)
    let val = Number(this.quantityInput.value)
    if (max && val > max) this.quantityInput.value = max
    if (val < min) this.quantityInput.value = min
  }
}

customElements.define('quantity-stepper', quantityStepper)

class ModalDialog extends HTMLElement {
  constructor() {
    super()
    this.content = this.querySelector('[role="dialog"]')
    this.querySelectorAll('[id^="ModalClose-"]').forEach((el) =>
      el.addEventListener('click', this.hide.bind(this))
    )
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide()
    })
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'MODAL-DIALOG') this.hide()
    })
  }

  show(opener) {
    const attributes = {
      tabindex: '0',
      'aria-hidden': 'false',
    }
    this.openedBy = opener
    __THEME_GLOBALS__.disableScroll()
    __THEME_GLOBALS__.setAttributes(this.content, attributes)
    this.setAttribute('open', '')
    setTimeout(() => this.content.focus(), 500)
  }

  hide() {
    const attributes = {
      tabindex: '-1',
      'aria-hidden': 'true',
    }
    __THEME_GLOBALS__.enableScroll()
    __THEME_GLOBALS__.setAttributes(this.content, attributes)
    this.removeAttribute('open')
    this.content.blur()

    if (this.id === 'PopupModal--quick-add') this.closeQuickAdd()
  }

  closeQuickAdd() {
    this.querySelector('#modalContent').innerHTML = ''
    this.querySelector('#emptyQvModal').classList.remove('is-hidden')
  }
}
customElements.define('modal-dialog', ModalDialog)

class ModalOpener extends HTMLElement {
  constructor() {
    super()

    const button = this.querySelector('button')

    if (!button) return
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'))
      if (modal) modal.show(button)
    })
  }
}
customElements.define('modal-opener', ModalOpener)

// Dropdown
class Dropdown extends HTMLElement {
  constructor() {
    super()
    document.addEventListener('click', (e) => this.dropdownToggle(e))
  }

  dropdownToggle(e) {
    if (
      this.contains(e.target) &&
      !e.target.closest('[data-dropdown-content]')
    ) {
      e.target.closest('[data-dropdown]').classList.toggle('active')
    } else {
      this.classList.remove('active')
    }
  }
}

customElements.define('dropdown-toggle', Dropdown)
// End dropdown

// Slide toggle
class SlideToggle extends HTMLElement {
  constructor() {
    super()
    this.duration = this.dataset.duration || 250
    this.slideTargetName = this.getAttribute('data-slide-toggle')
    this.slideTarget = document.querySelector(
      '[data-slide-target="' + this.slideTargetName + '"]'
    )
    if (this.slideTarget) {
      this.addEventListener('click', (e) => {
        e.preventDefault()
        this.closest('product-key-features')
          ?.querySelectorAll('.dropdownHeader.active')
          ?.forEach((el) => el.classList.remove('active'))
        this.classList.toggle('active')
        __THEME_GLOBALS__.slideToggle(this.slideTarget, this.duration)
      })
    }
  }
}

customElements.define('slide-toggle', SlideToggle)
// End Slide toggle

// Toggle tabs
class ToggleTabs extends HTMLElement {
  // Required button element: data-selected='true/false'; aria-controls='TAB_ID'; data-action='toggle-tab'
  // Required tab element: data-selected='true/false'; data-tab='TAB_ID'
  constructor() {
    super()
    this.buttons = this.querySelectorAll('[data-action="toggle-tab"]')
    this.tabs = this.querySelectorAll('[data-tab]')

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.toggleTab(button))
    })
  }

  toggleTab(button) {
    if (button.dataset.selected === 'true') return
    const tabId = button.getAttribute('aria-controls'),
      tabToShow = Array.from(this.tabs).find((tab) => tab.dataset.tab === tabId)
    this.buttons.forEach((el) => (el.dataset.selected = 'false'))
    this.tabs.forEach((tab) => (tab.dataset.selected = 'false'))
    button.dataset.selected = 'true'
    tabToShow.dataset.selected = 'true'
  }
}

customElements.define('toggle-tabs', ToggleTabs)
// End Toggle tabs

class StickyScrolling extends HTMLElement {
  constructor() {
    super()
    this.element = this.querySelector('.pdpMain__details')
    if (!this.element) return false
    this.topSpacer = document.getElementById('MainHeader').offsetHeight + 24
    this.lastScrollPosition = window.scrollY
    this.currentScrollPosition = window.scrollY
    this.elementDetails = {}

    this.init()
    document.addEventListener('resize', () => this.recalculateHeights())
    document.addEventListener('scroll', () => this.updatePosition())
  }

  init() {
    this.recalculateHeights()
    this.updatePosition()
  }

  recalculateHeights() {
    this.viewportHeight = window.innerHeight
    this.startPosition =
      this.parentElement.getBoundingClientRect().top + window.scrollY
    this.endPosition =
      this.parentElement.offsetHeight + this.startPosition - this.viewportHeight
    this.elementDetails = {
      height: this.element.offsetHeight,
      position: this.elementDetails.hasOwnProperty('position')
        ? this.elementDetails.position + 'px'
        : '0px',
    }
  }

  updatePosition() {
    this.currentScrollPosition = window.scrollY
    const overflow =
      this.topSpacer + this.elementDetails.height - this.viewportHeight
    let position = this.elementDetails.position
    position += this.currentScrollPosition - this.lastScrollPosition
    position = this.currentScrollPosition <= this.startPosition ? 0 : position
    position =
      this.currentScrollPosition > this.endPosition ? overflow : position
    position =
      Math.abs(position) === position && Math.abs(position) > overflow
        ? overflow
        : position
    position = Math.abs(position) !== position ? 0 : position
    this.elementDetails.position = position
    this.element.style.top = `${this.topSpacer + position * -1}px`
    this.lastScrollPosition = this.currentScrollPosition
    this.checkElementHeight()
  }

  checkElementHeight() {
    if (this.element.offsetHeight === this.elementDetails.height) return
    this.elementDetails.height = this.element.offsetHeight
  }
}

customElements.define('sticky-scrolling', StickyScrolling)

class PdpHelper extends HTMLElement {
  constructor() {
    super()
  }

  getSelectedVariant(optionsArr) {
    return this.productVariants.find((variant) => {
      return !variant.options
        .map((option, index) => {
          let optionValue = option
          if (optionValue.includes(':'))
            optionValue = optionValue.split(':')[1].trim()
          return optionsArr[index] === __THEME_GLOBALS__.handleize(optionValue)
        })
        .includes(false)
    })
  }

  getClosestVariant(options) {
    return this.productVariants.find((variant) => {
      const optionValue = variant.option1.includes(':')
        ? variant.option1.split(':')[1].trim()
        : variant.option1
      return options[0] === __THEME_GLOBALS__.handleize(optionValue)
    })
  }

  getOptions() {
    return this.radioGroups.map((radioGroup) => {
      return Array.from(radioGroup.querySelectorAll('input')).find(
        (radio) => radio.checked
      )?.value
    })
  }

  changeSelectedOption() {
    if (this.selectedVariant) {
      this.select.removeAttribute('data-unavailable')
      this.options.forEach((option) => option.removeAttribute('selected'))
      this.selectedOption = this.querySelector(
        `option[value='${this.selectedVariant.id}']`
      )
      this.selectedOption.getAttribute('data-variant-preorder')
        ? this.selectedOption.parentElement.setAttribute(
            'data-selected-variant-preorder',
            'true'
          )
        : this.selectedOption.parentElement.removeAttribute(
            'data-selected-variant-preorder'
          )
      this.selectedOption.setAttribute('selected', 'selected')
      this.select.setAttribute('value', this.selectedVariant.id)
    } else {
      this.select.setAttribute('data-unavailable', 'true')
    }
  }

  disableUnavailableVariants() {
    this.radios.forEach((radio) => {
      radio.classList.remove('soldout')
      radio.classList.remove('unavailable')
      radio.setAttribute('tabindex', 0)
    })

    for (let i = 0; i < this.selectedOptions.length; i++) {
      const groupRadios = this.radioGroups[i]?.querySelectorAll('.radio input')

      groupRadios?.forEach((radio) => {
        const options = [...this.selectedOptions]
        options.splice(i, 1, radio.value)

        if (!this.getSelectedVariant(options)) {
          if (i !== 0) radio.parentElement.classList.add('hidden')

          const alwaysEnabled =
            radio.parentElement.dataset.alwaysEnabled === 'true'

          if (alwaysEnabled) return

          radio.parentElement.classList.add('unavailable')
          radio.parentElement.removeAttribute('tabindex')
        } else {
          radio.checked = this.selectedOptions[i] === radio.value

          radio.parentElement.classList.remove('hidden')

          if (!this.getSelectedVariant(options).available) {
            radio.parentElement.classList.add('soldout')
          }
        }
      })
    }
  }

  checkVariantTitle() {
    this.optionTitles.forEach((title) => (title.innerHTML = ''))
    this.checkedOptions = this.form.querySelectorAll(
      'input:checked:not(.js-is-gift)'
    )
    this.checkedOptions.forEach((option) => {
      const optionGroup = option.closest('.option-groups__item'),
        optionSingle = option.closest('.pdp__options-item'),
        optionSelector = optionGroup ? optionGroup : optionSingle
      const optionTitle = optionSelector?.querySelector('.option-title-value')
      if (optionTitle) optionTitle.innerHTML = `${option.title}`
    })
  }

  checkSizeSelected() {
    if (this.sizeSelected) return
    this.querySelectorAll('[data-disabled-size="true"]').forEach((el) => {
      el.removeAttribute('data-disabled-size')
    })
    if (this.personalizeBtn)
      this.personalizeBtn.querySelector('.customize-btn').style.display =
        'block'
    this.sizeSelected = true
  }

  toggleAddButton(buttonsArr) {
    const preOrder = this.select.hasAttribute('data-selected-variant-preorder')

    if (__THEME_GLOBALS__.isHidden(this.atc) && this.klaviyoOOS?.length > 0) {
      this.atc.classList.remove('is-hidden')
      this.stickyATC?.classList.remove('hidden')
      this.klaviyoOOS.forEach((btn) =>
        btn.parentElement.classList.add('is-hidden')
      )
    }

    buttonsArr.forEach((btn) => {
      if (!btn) return
      if (!this.selectedVariant) {
        __THEME_GLOBALS__.changeBtnState(btn, 'disabled', 'Unavailable')
      } else if (preOrder) {
        __THEME_GLOBALS__.changeBtnState(btn, 'active', 'Pre-order')
      } else if (!this.selectedVariant.available) {
        __THEME_GLOBALS__.changeBtnState(btn, 'disabled', 'Out Of Stock')
        if (this.klaviyoOOS?.length > 0) this.outOfStock()
      } else {
        __THEME_GLOBALS__.changeBtnState(btn, 'active', 'Add to Cart')
      }
    })
  }

  outOfStock() {
    if (this.stickyAtc) this.stickyAtc.removeAttribute('disabled')
    this.atc.classList.add('is-hidden')
    this.stickyATC?.classList.add('hidden')
    this.klaviyoOOS.forEach((btn) =>
      btn.parentElement.classList.remove('is-hidden')
    )
  }

  addToCart(e) {
    e.preventDefault()
    const bodyObj = __THEME_GLOBALS__.serializeObject(this.form),
      prop = {},
      selectedOption = this.select.querySelector('option:checked')

    if (window.__THEME_GLOBALS__.product_is_recommended)
      prop['_recommended_product'] = true
    if (this.select.hasAttribute('data-selected-variant-preorder'))
      prop['pre-order'] = true
    if (selectedOption.hasAttribute('data-variant-current-coffee'))
      prop['First Shipment'] = selectedOption.getAttribute(
        'data-variant-current-coffee'
      )
    if (this.form.dataset.lineItems) {
      const lineItemsObject = JSON.parse(this.form.dataset.lineItems)
      const lineItems = lineItemsObject && Object.values(lineItemsObject)
      const filteredLineItems = lineItems?.filter((item) => item)
      filteredLineItems?.forEach((item) => {
        prop[item.split('::')[0]] = item.split('::')[1]
      })
    }
    if (Object.keys(prop).length) bodyObj.properties = prop

    __THEME_GLOBALS__.cart.cartEvent(
      '/cart/add.js',
      bodyObj,
      true,
      __THEME_GLOBALS__.pdpErrorMessage
    )
  }

  priceChange() {
    let priceInner = `<h2 class="ml1 pdpCopy__header-price">
          ${__THEME_GLOBALS__.formatMoney(this.currentPrice, '${{amount}}')}
        </h2>
        ${
          this.currentMSRP && window.Shopify.shop.includes('wholesale')
            ? `
        <div class="pdp-line-item__price__msrp">MSRP ${__THEME_GLOBALS__.formatMoney(
          this.currentMSRP
        )}</div>
      `
            : ''
        }
        `

    if (this.currentComparePrice > this.currentPrice) {
      priceInner = `<div class="pdpCopy__price f aic">
          <span class="strike card__price--regular ml1 pdpCopy__header-price rel pr025">
            ${__THEME_GLOBALS__.formatMoney(
              this.currentComparePrice,
              '${{amount}}'
            )}
            <div class="price-round-arrow">
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="14" viewBox="0 0 25 14" fill="none">
                <path d="M21.8717 2.55273L22.064 7.23249L17.2605 7.54226" stroke="black" stroke-width="1.5"
                stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M21 6.49951C21 6.49951 16.3627 1.55385 10.0543 3.38802C3.74592 5.22219 1.9372 10.8949 1.9372 10.8949"
                stroke="black" stroke-width="1.5" stroke-linecap="round"></path>
              </svg>
            </div>
          </span>
          <h2 class="card__price--sale ml1 pdpCopy__header-price">
            ${__THEME_GLOBALS__.formatMoney(this.currentPrice, '${{amount}}')}
          </h2>
          ${
            this.currentMSRP && window.Shopify.shop.includes('wholesale')
              ? `
          <div class="pdp-line-item__price__msrp">MSRP ${__THEME_GLOBALS__.formatMoney(
            this.currentMSRP
          )}</div>
        `
              : ''
          }
        </div>`
    }
    this.productPrice.innerHTML = priceInner
  }

  getEnabledVariants(variants, hiddenVariantIds) {
    if (hiddenVariantIds?.length) {
      return variants.filter(
        (variant) => !hiddenVariantIds.includes(variant.id)
      )
    } else {
      return variants
    }
  }
}
customElements.define('pdp-helper', PdpHelper)

class PdpStickyBar extends PdpHelper {
  constructor() {
    super()
    this.product = window.__THEME_GLOBALS__.product
    this.productVariants = this.getEnabledVariants(
      this.product['variants'],
      this.hiddenVariantIds
    )
    this.pdpContainer = this.closest('.pdpMain__container')
    this.radioGroups = this.querySelectorAll('.option-groups')
    this.radios = this.querySelectorAll('.radio')
    this.selectSizeBtn = this.querySelector('.cart__button--select-size')
    this.sizeLabel = this.querySelector(
      '[data-option-label="Size"] .option-title strong'
    )
    this.sizeCheckedLabel = this.querySelector(
      '[data-option-size] label.checked'
    )

    document.addEventListener('scroll', () => this.showStickyBar())
    if (this.selectSizeBtn) {
      this.selectSizeBtn.addEventListener('click', () => this.scrollToTop())
    }
  }

  stickyBarVariantChange(selectedOptions, sizeSelected) {
    this.selectedOptions = selectedOptions
    this.selectedVariant = this.getSelectedVariant(this.selectedOptions)
    this.checkActiveRadios()
    this.disableUnavailableVariants()
    if (sizeSelected) this.changeSizeLabel()
  }

  changeSizeLabel() {
    this.sizeCheckedLabel = this.querySelector(
      '[data-option-size] label.checked'
    )
    this.sizeLabel.innerHTML =
      this.sizeCheckedLabel.querySelector('input').title
  }

  checkActiveRadios() {
    this.radioGroups.forEach((optionGroup, i) => {
      const groupRadios = optionGroup.querySelectorAll('.radio'),
        checkedRadio = optionGroup.querySelector(
          '[for="' + this.selectedOptions[i] + '"]'
        )
      groupRadios.forEach((radio) => radio.classList.remove('checked'))
      checkedRadio.classList.add('checked')
    })
  }

  showStickyBar() {
    const pdpDetailsPosition = this.pdpContainer.getBoundingClientRect()
    pdpDetailsPosition.bottom < 0
      ? this.classList.add('show')
      : this.classList.remove('show')
  }

  scrollToTop() {
    if (window.innerWidth < 1200) {
      const topPosition = this.pdpContainer.offsetTop
      window.scrollTo({ top: topPosition, behavior: 'smooth' })
    }
  }
}

customElements.define('pdp-sticky-bar', PdpStickyBar)

class PdpMain extends PdpHelper {
  constructor() {
    super()
    this.product = window.__THEME_GLOBALS__.product
    this.hiddenVariantIds = window.__THEME_GLOBALS__.hiddenVariants
    this.productVariants = this.getEnabledVariants(
      this.product['variants'],
      this.hiddenVariantIds
    )
    this.media = this.querySelector('.pdpMain__Media')
    this.price = this.querySelectorAll('.pdpCopy__price')
    this.form = this.querySelector('.pdpForm')
    this.optionTitles = this.form.querySelectorAll('.option-title-value')
    this.quantity = this.form.querySelector('[name="quantity"]')
    this.sizeOptions = this.form.querySelectorAll('[data-option-size] .radio')
    this.select = this.form.querySelector('.select-wrapper select')
    this.options = this.select.querySelectorAll('option')
    this.radioGroups = Array.from(
      this.form.querySelectorAll('[data-option-radio]')
    )
    this.radios = this.form.querySelectorAll('.radio')
    this.atc = this.form.querySelector('.js-add-to-cart')
    this.redeemATC = this.form.querySelector('.js-gift-add-to-cart')
    this.stickyAtc = this.querySelector('#pdp-sticky-atc')
    this.klaviyoOOS = this.querySelectorAll('.klaviyo-bis-trigger')
    this.stickyATC = this.querySelector('.sticky-atc')
    this.stickyBar = this.querySelector('pdp-sticky-bar')
    this.personalizeBtn = this.form.querySelector('.pdpDetails__personalize')
    this.personalizeBtnWrapper = this.form.querySelector(
      '.pdpDetails__personalize-wrapper'
    )
    this.upsell = this.querySelector('.upsell-product')
    this.isGiftSubscriptionEl = this.querySelector('.js-is-gift')

    this.isSubscription = this.getAttribute('is-subscription') ? true : false
    this.isGiftSubscription = this.isSubscription
      ? this.isGiftSubscriptionEl.checked
      : false

    this.subscriptionContainer = this.querySelector(
      '.pdp-subscription-container'
    )
    this.redeemGiftContainer = this.querySelector('.pdp-gift-redeem-container')
    this.redirectLineItemsBtn = this.querySelector('.js-redirect-line-items')

    const MAX_QTY_SUBS_PERSONAL = 4
    const MAX_QTY_SUBS_GIFT = 2

    const setMaxSubscriptionQty = () => {
      const val = this.quantity.value
      const maxVal = this.isGiftSubscription
        ? MAX_QTY_SUBS_GIFT
        : MAX_QTY_SUBS_PERSONAL
      if (val > maxVal) {
        this.quantity.value = maxVal
      }

      this.quantity.setAttribute('max', maxVal)
    }

    const getSubscriptionVariantPrices = () => {
      let variants = {}
      Govalo.variants.forEach((variant) => {
        variants[variant.title.toLowerCase()] =
          '$' + variant.value.replace('.00', '')
      })

      return variants
    }

    this.checkCartToggle()

    this.onVariantChange()

    if (this.personalizeBtn) {
      this.triggerCustomizeBtn()
    }

    this.checkGiftRedeeemSubscription()

    this.form.addEventListener('change', () => {
      this.onVariantChange()
      this.changeContent()
      this.changeUrl()

      this.isGiftSubscription = this.isSubscription
        ? this.isGiftSubscriptionEl.checked
        : false

      if (this.isGiftSubscription) {
        let plan = $('input[name="Plan"]:checked').val()
        let roast = $('input[name="Roast"]:checked').val()
        let shipments = $('select[name="number_of_shipments"]').val()
        let variantPrices = getSubscriptionVariantPrices()
        let currentVariant = plan + ' / ' + roast + ' / ' + shipments

        $('#shipment_number_copy_parent').removeClass('invisible')
        $('.js-product-title').hide()
        $('.js-product-title-gift').show()
        $('.js-normal-price-shipping').hide()
        $('.js-varies-price-msg').hide()

        if (variantPrices.hasOwnProperty(currentVariant)) {
          $('.js-normal-price').html(variantPrices[currentVariant])
        } else {
          $('.js-normal-price').html($('.js-gift-price').html())
        }
      } else {
        $('#shipment_number_copy_parent').addClass('invisible')
        $('.js-product-title-gift').hide()
        $('.js-product-title').show()
        $('.js-varies-price-msg').show()

        // To show correct price
        this.changeContent()
      }

      if (this.isSubscription) {
        setMaxSubscriptionQty()
      }

      const { name = '', valueHandle = '' } = event.target.dataset
      const stickyEl = document.querySelector('sticky-cta')
      if (name == 'color' && stickyEl) stickyEl.selectValue(name, valueHandle)
    })
    // Shipping price
    this.quantity.addEventListener('change', () => {
      if (this.isSubscription) {
        setMaxSubscriptionQty()
      }

      // const SHIPPING_PRICE_THRESHOLD_QTY = 2
      // const newShippingPrice = this.quantity.value > SHIPPING_PRICE_THRESHOLD_QTY ? 10 : 5

      // AV: for launch, set shipping price at $5 for any subscription order
      const newShippingPrice = 5
      $('.js-shipping-price').html(newShippingPrice)
    })

    if (!!this.redirectLineItemsBtn) {
      this.redirectLineItemsBtn.addEventListener('click', (e) => {
        e.preventDefault()
        const element = document.querySelector('#pdp-line-items-chart')
        if (!element) return

        const topPosition = element.offsetTop
        const headerHeight = document.querySelector('#header').clientHeight
        window.scrollTo({ top: topPosition - headerHeight, behavior: 'smooth' })
      })
    }

    if (!!this.atc) {
      this.atc.addEventListener('click', (e) => {
        if (this.isGiftSubscription) {
          e.preventDefault()
          const gvloTrigger = document.querySelector('.gvlo-trigger')
          if (gvloTrigger) {
            govaloPdpModal.init()
            gvloTrigger.click()
            setTimeout(() => {
              govaloPdpModal.trapFocus()
            }, 500)
            $('body').css('overflow', 'hidden')
          } else {
            console.warn(
              'Cannot find Govalo widget. Make sure the app embed is enabled.'
            )
          }
        } else {
          this.addToCart(e)
        }
      })
    }

    document.addEventListener('sticky:atc', () => {
      if (this.atc) {
        this.atc.click()
      }
    })

    if (!!this.redeemATC) {
      this.redeemATC.addEventListener('click', (e) => {
        this.addToCart(e)
      })
    }

    if (this.stickyAtc)
      this.stickyAtc.addEventListener('click', (e) => {
        __THEME_GLOBALS__.isHidden(this.atc)
          ? this.klaviyoOOS.forEach((btn) => btn.click())
          : this.addToCart(e)
      })

    if (this.sizeOptions.length) {
      Array.from(this.sizeOptions)
        .map((option) => option.querySelector('[type="radio"]'))
        .map((radio) => {
          radio.addEventListener('change', () => {
            this.checkSizeSelected()
            if (this.stickyBar)
              this.stickyBar.stickyBarVariantChange(
                this.selectedOptions,
                this.sizeSelected
              )
          })
        })
    }

    if (this.isSubscription) {
      $('.gvlo-trigger').addClass('invisible').css({ maxHeight: 0 })
      $('label[for="premium-gift"]').addClass('hidden').css({ maxHeight: 0 })
      $('label[for="classic-gift"]').addClass('hidden').css({ maxHeight: 0 })
    }

    setTimeout(() => {
      const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
      })

      if (params.is_gift == 1) {
        $('#send_as_gift').click()
      }
    }, 1500)
  }

  checkCartToggle() {
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    })

    if (!!params.show_cart) {
      setTimeout(() => {
        window.history.replaceState(
          {},
          '',
          `${window.location.origin}/products/${this.product.handle}`
        )
        __THEME_GLOBALS__.cart.openDrawer()
      }, 1500)
    }
  }

  getCookie(name) {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) {
      return parts.pop().split(';').shift()
    }
  }

  checkSubscriptionGiftVariantSelected() {
    if (this.selectedVariant?.title.toLowerCase().includes('gift')) {
      $('#pdp-atc').prop('disabled', true)
    }
  }

  checkGiftRedeeemSubscription() {
    const discountCode = this.getCookie('discount_code')

    const urlParams = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    })

    if (
      this.isSubscription &&
      !!discountCode &&
      urlParams.src === 'gvlo' &&
      !!urlParams.cycles
    ) {
      this.form.classList.add('pdp-gift-redeem-form')
      if (!!this.subscriptionContainer)
        this.subscriptionContainer.classList.add('d-none')
      if (!!this.redeemGiftContainer)
        this.redeemGiftContainer.classList.remove('d-none')
      if (!!this.querySelector('[data-pdp-gift-redeem-cycles]'))
        this.querySelector('[data-pdp-gift-redeem-cycles]').innerHTML =
          urlParams.cycles

      const giftVariant = this.productVariants.find(
        (variant) =>
          variant.sku === this.selectedVariant.sku &&
          variant.title.toLowerCase().includes('gift')
      )

      if (giftVariant) {
        $('[name="id"]').val(giftVariant.id)
      }

      if (!!urlParams.selling_plan) {
        this.waitForSelector({
          name: 'selling plan dropdown',
          selector: '[name="selling_plan"]',
        }).then(() => {
          $('[name="selling_plan"]').val(urlParams.selling_plan)
        })
      }
    } else {
      if (!!this.subscriptionContainer)
        this.subscriptionContainer.classList.remove('d-none')
      if (!!this.redeemGiftContainer)
        this.redeemGiftContainer.classList.add('d-none')

      this.checkSubscriptionGiftVariantSelected()

      if (urlParams.is_gift === 'true') {
        if (!!this.querySelector('#send_as_gift')) {
          this.querySelector('#send_as_gift').checked = true
          this.waitForSelector({
            name: 'gvlo trigger',
            selector: '.gvlo-trigger',
          }).then(() => {
            this.form.dispatchEvent(new Event('change'))
            window.history.replaceState(
              {},
              document.title,
              window.location.pathname
            )
          })
        }
      }
    }
  }

  triggerCustomizeBtn() {
    window.addEventListener(
      'options:rendered',
      () => {
        this.personalizeBtn.addEventListener('click', (e) => {
          e.preventDefault()
          const customizeBtn = document
            .querySelector('.cl-po--wrapper')
            .querySelector('.cl-po--input')
          customizeBtn.click()
        })
      },
      { once: true }
    )
  }

  onVariantChange() {
    this.selectedOptions = this.getOptions()

    const selectedVariant = this.getSelectedVariant(this.selectedOptions)
    this.selectedVariant = selectedVariant
      ? selectedVariant
      : this.getClosestVariant(this.selectedOptions)

    if (!selectedVariant)
      this.selectedOptions = this.selectedVariant.options.map(
        (option, index) => {
          let optionValue = option
          if (optionValue.includes(':'))
            optionValue = optionValue.split(':')[1].trim()
          return __THEME_GLOBALS__.handleize(optionValue)
        }
      )

    window.selectedVariant = this.selectedVariant
    window.dispatchEvent(
      new CustomEvent('variant-change', {
        detail: {
          variant: window.selectedVariant,
        },
      })
    )

    this.changeSelectedOption()
    this.disableUnavailableVariants()
    this.checkVariantTitle()
    this.toggleAddButton([this.atc, this.stickyAtc])

    if (this.personalizeBtn) this.setVariantForPersonalize()
    if (this.stickyBar)
      this.stickyBar.stickyBarVariantChange(
        this.selectedOptions,
        this.sizeSelected
      )

    if (this.isSubscription) {
      const plan = this.selectedOptions[0]
      $('.js-plan-msg').hide()
      $(`.js-plan-msg-${plan}`).show()

      const roast = this.selectedOptions[1] || ''
      const roastName = roast.replaceAll(' ', '-').toLowerCase()
      $('.js-roast-msg').hide()
      $(`.js-roast-msg-${roastName}`).show()
    }
  }

  changeUrl() {
    if (!this.selectedVariant) return
    window.history.replaceState(
      {},
      '',
      `${window.location.origin}/products/${this.product.handle}?variant=${this.selectedVariant.id}`
    )
  }

  setVariantForPersonalize() {
    window.localStorage.setItem('changeVariant', 'true')
    if (this.selectedVariant) {
      window.localStorage.setItem('variantId', this.selectedVariant.id)
    }
  }

  changeContent() {
    if (!this.selectedVariant) return
    const selectedView = this.isSubscription
      ? 'ajax-media-subscription'
      : 'ajax-media'

    fetch(
      window.location.origin +
        window.location.pathname +
        '?variant=' +
        this.selectedVariant.id +
        `&view=${selectedView}`
    )
      .then((response) => response.text())
      .then((data) => {
        const html = new DOMParser().parseFromString(data, 'text/html')

        this.media.innerHTML = html.querySelector(
          '.product-main-section .pdpMain__Media'
        ).innerHTML

        if (this.querySelector('.js-brand-value-props'))
          this.querySelector('.js-brand-value-props').innerHTML =
            html.querySelector('.js-brand-value-props').innerHTML
        if (this.querySelector('.js-customize-callout'))
          this.querySelector('.js-customize-callout').innerHTML =
            html.querySelector('.js-customize-callout').innerHTML

        for (const badge of document.querySelectorAll('.js-product-badges')) {
          badge.innerHTML = html.querySelector('.js-product-badges').innerHTML
        }

        for (const buttonContainer of document.querySelectorAll(
          '.js-pdp-detail-btns'
        )) {
          const btnWrapper = html.querySelector('.js-pdp-detail-btns')

          buttonContainer.setAttribute(
            'data-shipdate',
            btnWrapper.getAttribute('data-shipdate')
          )
          buttonContainer.setAttribute(
            'data-preorder',
            btnWrapper.getAttribute('data-preorder')
          )
          buttonContainer.setAttribute(
            'data-available',
            btnWrapper.getAttribute('data-available')
          )

          if (!!btnWrapper.getAttribute('data-shipdate')) {
            buttonContainer.querySelector(
              '[data-native-pre-order-btn]'
            ).innerHTML = `Add To Cart - Ships ${btnWrapper.getAttribute(
              'data-shipdate'
            )}`
          }
        }

        if (!this.isGiftSubscription) {
          this.price.forEach((price) => {
            price.innerHTML = html.querySelector(
              '.product-main-section .pdpCopy__price'
            ).innerHTML
          })
        }

        if (document.querySelector('.js-learn-more-image')) {
          // get the main variant imge from the returned HTML
          const imageElement = html
            .querySelector('.pdpMain__variant-image')
            .querySelector('img')
          // remove the absolute cover class
          imageElement.classList.remove('image-abs-cover')

          // set the learn more image container to be the new image element
          document.querySelector('.js-learn-more-image').innerHTML =
            imageElement.outerHTML
        }

        this.exchangeDocumentContent(html, '.js-product-key-features')
        this.exchangeDocumentContent(html, '.js-pdp-learn-more')

        const personalizeBtnWrapper = html.querySelector(
          '.pdpDetails__personalize-wrapper'
        )

        if (personalizeBtnWrapper && this.personalizeBtnWrapper) {
          this.personalizeBtnWrapper.classList = personalizeBtnWrapper.classList
        }

        const upsell = html.querySelector('.upsell-product')

        if (this.upsell) {
          this.upsell.innerHTML = upsell.hasChildNodes() ? upsell.innerHTML : ''
        }

        const form = html.querySelector('form.pdpForm')

        if (this.form && form) {
          this.form.dataset.lineItems = form.dataset.lineItems
        }

        const formProperties = html.querySelector('[data-line-items-inputs]')

        if (
          this.form.querySelector('[data-line-items-inputs]') &&
          formProperties
        ) {
          this.form.querySelector('[data-line-items-inputs]').innerHTML =
            formProperties.innerHTML
        }

        __THEME_GLOBALS__.slickSlider()

        if (
          this.querySelector('.js-highlights') &&
          html.querySelector('.pdpHighlights')
        )
          this.querySelector('.js-highlights').innerHTML =
            html.querySelector('.pdpHighlights').innerHTML
      })
  }

  exchangeDocumentContent(html, selector) {
    if (html.querySelector(selector) && document.querySelector(selector)) {
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML
    }
  }

  waitForSelector({ name, selector }) {
    return new Promise((resolve, reject) => {
      let count = 0
      const interval = setInterval(() => {
        count++
        const elem = document.querySelector(selector)
        if (elem) {
          clearInterval(interval)
          resolve(elem)
        }
        if (count >= 24) {
          clearInterval(interval)
          reject(new Error(`Cannot find ${name}`))
        }
      }, 500)
    })
  }
}

customElements.define('pdp-main', PdpMain)

class PdpGallery extends HTMLElement {
  constructor() {
    super()
    this.container = this.closest('.pdpMain__Media')
    this.variantImages = this.querySelectorAll('.pdpMain__variant-image')
    this.thumbnailsGallery = this.querySelectorAll(
      '.pdpMain__gallery-thumbnails'
    )
    this.thumbnails = this.querySelectorAll('.pdpMain__gallery-thumbnails-item')
    this.gallery = this.querySelector('.pdpMain__gallery-wrapper')

    this.mainGallery()
    this.syncArrows()

    Fancybox.bind('[data-fancybox="gallery"]', {
      Thumbs: {
        type: 'classic',
      },
      Toolbar: {
        display: {
          left: ['infobar'],
          middle: [],
          right: ['iterateZoom', 'close'],
        },
      },
      on: {
        'Carousel.change': (fancybox) => {
          const { page } = fancybox.carousel
          $(this.thumbnailsGallery).slick('slickGoTo', parseInt(page), true)
          $(this.gallery).slick('slickGoTo', parseInt(page), true)
        },
      },
    })

    const observer = new MutationObserver((entries) => {
      const entry = entries[0]
      const oldBodyClass = entry.oldValue

      if (
        oldBodyClass.includes('redesign') ===
        document.body.classList.contains('redesign')
      )
        return

      if (window.selectedVariant) {
        fetch(
          window.location.origin +
            window.location.pathname +
            '?variant=' +
            window.selectedVariant.id +
            `&view=ajax-media`
        )
          .then((response) => response.text())
          .then((data) => {
            const html = new DOMParser().parseFromString(data, 'text/html')

            document.querySelector(
              '.product-main-section .pdpMain__Media'
            ).innerHTML = html.querySelector(
              '.product-main-section .pdpMain__Media'
            ).innerHTML

            __THEME_GLOBALS__.slickSlider()
          })
      }
    })

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
      attributeOldValue: true,
      childList: false,
      characterData: false,
    })

    window.addEventListener('resize', () => {
      const config = $('.js-pdp-gallery-redesign').data('slick-config')
      $('.js-pdp-gallery-thumbs').slick('unslick')

      __THEME_GLOBALS__.checkSlickResponse(
        '.js-pdp-gallery-thumbs',
        config,
        false,
        false
      )
    })
  }

  thumbnailScrollOnClick(thumbnail) {
    if (thumbnail.classList.contains('current-thumbnail')) return

    const id = thumbnail.getAttribute('data-variant-img'),
      scrollElement = this.querySelector('[data-variant-media="' + id + '"]'),
      headerHeight = document.getElementById('MainHeader').offsetHeight,
      topPosition = scrollElement.offsetTop + headerHeight
    window.scrollTo({ top: topPosition, behavior: 'smooth' })
    this.thumbnails.forEach((item) =>
      item.classList.remove('current-thumbnail')
    )
    thumbnail.classList.add('current-thumbnail')
  }

  changeActiveThumbnail() {
    this.variantImages.forEach((image) => {
      let imagePosition = image.getBoundingClientRect()
      if (imagePosition.top < 300) {
        const id = image.getAttribute('data-variant-media')
        const thumbnailImage = this.querySelector(
          '[data-variant-img="' + id + '"]'
        )
        let slideIndex = thumbnailImage.dataset.slickIndex
        this.thumbnails.forEach((item) =>
          item.classList.remove('current-thumbnail')
        )
        thumbnailImage.classList.add('current-thumbnail')
        $(this.thumbnailsGallery).slick('slickGoTo', parseInt(slideIndex), true)
      }
    })
  }

  mainGallery() {
    let config = JSON.parse(this.gallery.getAttribute('data-slick-config'))

    if (window.innerWidth > 992) {
      config['slide'] = '.x:not(.hide-desktop)'
    } else {
      config['slide'] = '.x:not(.hide-mobile)'
    }

    __THEME_GLOBALS__.checkSlickResponse(
      '.product-main-section .pdpMain__gallery-wrapper',
      config,
      false,
      false
    )
  }

  adjustArrows() {
    const $mainGallery = $('.product-main-section .pdpMain__gallery-wrapper')
    const $thumbsGallery = $(
      '.product-main-section .pdpMain__gallery-thumbnails'
    )
    if ($mainGallery.find('.slick-next').hasClass('slick-disabled')) {
      $thumbsGallery.find('.slick-next').addClass('slick-arrow-disabled')
    } else {
      $thumbsGallery.find('.slick-next').removeClass('slick-arrow-disabled')
    }
    if ($mainGallery.find('.slick-prev').hasClass('slick-disabled')) {
      $thumbsGallery.find('.slick-prev').addClass('slick-arrow-disabled')
    } else {
      $thumbsGallery.find('.slick-prev').removeClass('slick-arrow-disabled')
    }
  }

  syncArrows() {
    const $mainGallery = $('.product-main-section .pdpMain__gallery-wrapper')
    const $thumbsGallery = $(
      '.product-main-section .pdpMain__gallery-thumbnails'
    )
    $mainGallery.on('afterChange', this.adjustArrows.bind(this))
    $mainGallery.on('beforeChange', this.adjustArrows.bind(this))
  }
}

customElements.define('pdp-gallery', PdpGallery)

class UpsellProduct extends PdpHelper {
  constructor() {
    super()
    this.product = JSON.parse(
      this.querySelector('[type="application/json"]').textContent
    )
    this.productVariants = this.getEnabledVariants(
      this.product['variants'],
      this.hiddenVariantIds
    )
    this.optionTitles = this.querySelectorAll('.option-title-value')
    this.form = this
    this.price = this.querySelector('.upsell-product__content-price')
    this.select = this.querySelector('.js-product-upsell-variant select')
    this.options = this.select.querySelectorAll('option')
    this.radioGroups = Array.from(
      this.querySelectorAll('.upsell-product__option-group')
    )
    this.radios = this.querySelectorAll('.upsell-radio')
    this.atc = this.querySelector('.js-upsell-add-to-cart')

    this.onUpsellVariantChange()
    this.addEventListener('change', () => this.onUpsellVariantChange())
    this.atc.addEventListener('click', (e) => this.upsellAddToCart(e))
  }

  onUpsellVariantChange() {
    this.selectedOptions = this.getOptions()
    this.selectedVariant = this.getSelectedVariant(this.selectedOptions)
    this.disableUnavailableVariants()
    this.changeUpsellImage()
    this.checkVariantTitle()
    this.changePrice()
    this.changeSelectedOption()
    this.toggleAddButton([this.atc])
  }

  changeUpsellImage() {
    if (!this.selectedVariant) return
    const selectedImage = this.querySelector(
      '[data-upsell-variant-media="' + this.selectedVariant.id + '"]'
    )
    this.querySelector('[data-upsell-variant-media].visible').classList.remove(
      'visible'
    )
    selectedImage.classList.add('visible')
  }

  changePrice() {
    if (!this.selectedVariant) return
    this.price.innerHTML = __THEME_GLOBALS__.formatMoney(
      this.selectedVariant.price,
      '${{amount}}'
    )
  }

  upsellAddToCart(e) {
    e.preventDefault()
    const bodyObj = { id: this.selectedVariant.id, quantity: 1 }
    if (this.select.hasAttribute('data-selected-variant-preorder')) {
      bodyObj.properties = {
        'pre-order': true,
      }
    }
    __THEME_GLOBALS__.cart.cartEvent(
      '/cart/add.js',
      bodyObj,
      true,
      __THEME_GLOBALS__.pdpErrorMessage
    )
  }
}

customElements.define('upsell-product', UpsellProduct)

class PdpLearnMore extends HTMLElement {
  constructor() {
    super()
    this.additionalPanel = this.querySelector('.js-learn-more-additionals')
    this.expandButton = this.querySelector('.js-view-all')
  }

  connectedCallback() {
    this.expandButton?.addEventListener('click', () => {
      if (this.additionalPanel.classList.contains('expanded')) {
        this.additionalPanel.classList.remove('expanded')
        this.additionalPanel.style.maxHeight = 0
      } else {
        const height =
          this.additionalPanel.querySelector('.js-inner').offsetHeight
        this.additionalPanel.style.maxHeight = `${height}px`
        this.additionalPanel.classList.add('expanded')

        this.expandButton.classList.add('hide')

        setTimeout(() => {
          this.additionalPanel.style.maxHeight = 'unset'
        }, 300)
      }
    })

    this.watchSectionScroll()
  }

  onIntersection(entries, opts) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animated')
      }
    })
  }

  watchSectionScroll() {
    const observer = new IntersectionObserver(this.onIntersection, {
      root: null,
      threshold: 0.5,
    })
    if (this.querySelector('.js-learn-more-image') !== null) {
      observer.observe(this.querySelector('.js-learn-more-image'))
    }
  }
}

customElements.define('pdp-learn-more', PdpLearnMore)

class PdpCompare extends HTMLElement {
  constructor() {
    super()
    this.wrapper = this.querySelector('.pdpCompare__wrapper')
    this.tableHead = this.querySelector('.pdpCompare__table thead')
    this.tableBody = this.querySelector('.pdpCompare__table tbody')
    this.tableHeadMobile = this.querySelector('.pdpCompare__table-mobile-title')
    this.th = this.querySelectorAll('.pdpCompare__table .pdpCompare__table-th')
    this.changeTableHeight()
    window.addEventListener('resize', () => this.changeTableHeight())
    if (this.tableHeadMobile) this.checkStickyHeadMobile()
  }

  changeTableHeight() {
    this.th.forEach((th) => th.style.removeProperty('min-height'))
    const thHeight = this.tableHead.clientHeight - 24
    this.th.forEach((th) => (th.style.minHeight = thHeight + 'px'))
  }

  checkStickyHeadMobile() {
    window.addEventListener('scroll', () => {
      this.tableBodyPosition = this.tableBody.getBoundingClientRect()
      this.tableBodyPosition.top < 100 && this.tableBodyPosition.bottom > 200
        ? this.tableHeadMobile.classList.remove('is-hidden')
        : this.tableHeadMobile.classList.add('is-hidden')
    })

    this.wrapper.addEventListener('scroll', (e) => {
      const translateX = e.target.scrollLeft > 5 ? e.target.scrollLeft : 0
      this.tableHeadMobile.style.transform = `translateX(-${translateX}px)`
    })
  }
}

customElements.define('pdp-compare', PdpCompare)

class YoutubeVimeoVideo extends HTMLElement {
  constructor() {
    super()
    this.options = JSON.parse(this.dataset.videoOptions)
    if (!this.options['videoType']) return
    this.videoId = this.dataset.videoId
    this.playerWrapper = this.querySelector('.js-video-wrapper')
    this.playerInner = this.querySelector('.js-video-mount')
    this.playBtn = this.querySelector('.js-video-play-button')
    this.loadScript().then(this.setupPlayer.bind(this))

    this.playBtn.addEventListener('click', () => {
      if (this.player.A) this.player.playVideo()
      this.playerWrapper.classList.add('is-playing')
    })
  }

  loadScript() {
    return new Promise((resolve, reject) => {
      var script = document.createElement('script')
      document.body.appendChild(script)
      script.async = true
      script.src =
        this.options['videoType'] === 'youtube'
          ? '//www.youtube.com/iframe_api'
          : '//player.vimeo.com/api/player.js'
      script.onload = resolve
      script.onerror = reject
    })
  }

  setupPlayer() {
    const playerLoadingInterval = setInterval(() => {
      this.options['videoType'] === 'youtube'
        ? this.youtubeSetup(playerLoadingInterval)
        : this.vimeoSetup(playerLoadingInterval)
    }, 200)
  }

  youtubeSetup(playerLoadingInterval) {
    window.YT.ready(() => {
      this.player = new YT.Player(this.playerInner, {
        videoId: this.options['videoId'],
        playerVars: {
          rel: 0,
          height: '100%',
          width: '100%',
          iv_load_policy: 3,
          loop: 1,
          playsinline: 1,
          modestbranding: 1,
          origin: this.options['requestHost'],
        },
        events: {
          onReady: this.onPlayerReady(),
        },
      })

      clearInterval(playerLoadingInterval)
    })
  }

  vimeoSetup(playerLoadingInterval) {
    if (window.Vimeo) {
      this.player = new Vimeo.Player(this.playerInner.parentNode, {
        id: this.options['videoId'],
        muted: false,
        loop: true,
      })

      this.player.ready().then(() => this.onPlayerReady())
      clearInterval(playerLoadingInterval)
    }
  }

  onPlayerReady() {
    this.playerWrapper.classList.add('is-loaded')
  }
}

customElements.define('video-section', YoutubeVimeoVideo)

class MP4Video extends HTMLElement {
  constructor() {
    super()
    this.video = this.querySelector('.media-video')
    this.pauseBtn = this.querySelector('.pause-button')
    this.playBtn = this.querySelector('.play-button')
    this.muteBtn = this.querySelector('.mute-video')

    if (this.playBtn)
      this.playBtn.addEventListener('click', () => this.videoPlay())
    if (this.pauseBtn)
      this.pauseBtn.addEventListener('click', () => this.videoPause())
    if (this.muteBtn)
      this.muteBtn.addEventListener('click', () => this.videoMute())
    if (this.pauseBtn || this.playBtn)
      this.video.addEventListener('click', (e) => this.checkVideoState(e))
  }

  checkVideoState(e) {
    e.preventDefault()
    this.video.paused ? this.videoPlay() : this.videoPause()
  }

  videoPlay() {
    this.video.play()
    if (this.playBtn) this.playBtn.classList.add('hidden')
    if (this.pauseBtn) this.pauseBtn.classList.remove('hidden')
  }

  videoPause() {
    this.video.pause()
    if (this.playBtn) this.playBtn.classList.remove('hidden')
    if (this.pauseBtn) this.pauseBtn.classList.add('hidden')
  }

  videoMute() {
    const muted = this.video.hasAttribute('muted')
    muted
      ? this.video.removeAttribute('muted')
      : this.video.setAttribute('muted', '')
    if (this.muteBtn) this.muteBtn.classList.toggle('unmute-video')
  }
}

customElements.define('mp4-video', MP4Video)

class ProductCard extends PdpHelper {
  constructor() {
    super()
    this.options = this.querySelector('.productCard__options')
    this.colorSelectors = this.querySelectorAll('.js-color-update input')
    this.productLinks = this.querySelectorAll('.js-product-link')
    this.productView = this.querySelector('.js-product-view')
    this.productPrice = this.querySelector('.productCard__price-wrapper')
    this.variantImages = this.querySelectorAll('.js-variant-image')

    if (this.options)
      this.options.addEventListener('change', () => this.cardOptionChange())
    if (this.productView)
      this.productView.addEventListener('click', () => this.quickAdd())
  }

  cardOptionChange() {
    this.currentOpt = this.options.querySelector('input:checked')
    this.currentOptID = this.currentOpt.dataset.variantId
    this.currentOptLink = this.currentOpt.dataset.variantUrl
    this.currentPrice = this.currentOpt.dataset.variantPrice
    this.currentMSRP = this.currentOpt.dataset.variantMsrp
    this.currentComparePrice = this.currentOpt.dataset.variantComparePrice

    this.colorSelectors.forEach((i) => i.classList.remove('active'))
    this.currentOpt.classList.add('active')

    this.priceChange()
    this.cardLinksChange()
    this.cardImageChange()
  }

  cardLinksChange() {
    this.productLinks.forEach((link) => {
      link.setAttribute('href', this.currentOptLink)
    })

    if (!this.productView) return
    const searchParam = !this.currentOptLink.includes('variant=')
        ? '?view=quick-view'
        : '&view=quick-view',
      viewLink = this.currentOptLink + searchParam
    this.productView.setAttribute('data-quick-view', viewLink)
  }

  cardImageChange() {
    this.currentOptionImage = this.querySelector(
      '.productCard__img [data-variant-id="' + this.currentOptID + '"]'
    )
    if (!this.currentOptionImage) return
    this.variantImages.forEach((image) => image.classList.remove('is-visible'))
    this.currentOptionImage.classList.add('is-visible')
  }

  quickAdd() {
    const quickAddUrl = this.productView.dataset.quickView,
      quickAddModal = document.querySelector('#PopupModal--quick-add'),
      quickAddContent = quickAddModal.querySelector('#modalContent'),
      quickAddSkeleton = quickAddModal.querySelector('#emptyQvModal')

    fetch(quickAddUrl)
      .then((response) => response.text())
      .then((html) => {
        quickAddSkeleton.classList.add('is-hidden')
        quickAddContent.innerHTML = html
      })
  }
}

customElements.define('product-card', ProductCard)

class ProductQuickView extends PdpHelper {
  constructor() {
    super()
    this.product = JSON.parse(
      this.querySelector('[type="application/json"]').textContent
    )
    this.productVariants = this.getEnabledVariants(
      this.product['variants'],
      this.hiddenVariantIds
    )
    this.thumbnails = this.querySelector('.pdpMain__gallery-thumbnails')
    this.gallery = this.querySelector('.pdpMain__gallery-wrapper')
    this.productPrice = this.querySelector('.QuickView__Price')
    this.form = this.querySelector('form')
    this.optionTitles = this.form.querySelectorAll('.option-title-value')
    this.quantity = this.form.querySelector('[name="quantity"]')
    this.sizeOptions = this.form.querySelectorAll('[data-option-size] .radio')
    this.select = this.form.querySelector('.select-wrapper select')
    this.options = this.select.querySelectorAll('option')
    this.radioGroups = Array.from(
      this.form.querySelectorAll('[data-option-radio]')
    )
    this.radios = this.form.querySelectorAll('.radio')
    this.atc = this.form.querySelector('.js-add-to-cart')

    this.initGallery().then(() => this.quickViewVariantChange())

    this.form.addEventListener('change', () => {
      this.quickViewVariantChange()
    })

    if (this.sizeOptions.length) {
      this.sizeOptions.forEach((radio) =>
        radio.addEventListener('click', () => this.checkSizeSelected())
      )
    }

    this.atc.addEventListener('click', (e) => {
      this.addToCart(e)
      this.closest('#PopupModal--quick-add').hide()
    })
  }

  initGallery() {
    return new Promise((resolve) => {
      $(this.thumbnails).slick(JSON.parse(this.thumbnails.dataset.slickConfig))
      resolve()
    }).then(() => {
      $(this.gallery).slick(JSON.parse(this.gallery.dataset.slickConfig))
    })
  }

  quickViewVariantChange() {
    this.selectedOptions = this.getOptions()
    this.selectedVariant = this.getSelectedVariant(this.selectedOptions)
    this.currentPrice = this.selectedVariant['price']
    this.currentComparePrice = this.selectedVariant['compare_at_price']
    this.changeSelectedOption()
    this.disableUnavailableVariants()
    this.checkVariantTitle()
    this.priceChange()
    this.toggleAddButton([this.atc])
    this.quickViewSlideChange()
  }

  quickViewSlideChange() {
    if (!this.selectedVariant) return
    const currentImage = this.thumbnails.querySelector(
      '[data-variant-img="' + this.selectedVariant.id + '"]'
    )
    if (currentImage) {
      const index = currentImage.dataset.slickIndex
      $(this.thumbnails).slick('slickGoTo', index)
    }
  }
}

customElements.define('product-quick-view', ProductQuickView)

class FeaturedCollections extends HTMLElement {
  constructor() {
    super()
    this.tabs = this.querySelectorAll('[data-action="toggle-tab"]')
    this.link = this.querySelector('.FeaturedCollections__CollectionLink')
    this.arrows = this.querySelectorAll('[data-scroll]')

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.changeCollectionLink(tab))
    })
    this.arrows.forEach((arrow) => {
      arrow.addEventListener('click', () => this.scrollArrows(arrow))
    })
  }

  changeCollectionLink(tab) {
    this.link.setAttribute('href', tab.dataset.linkUrl)
    this.link.innerHTML = tab.dataset.linkTitle
  }

  scrollArrows(arrow) {
    const action = arrow.dataset.scroll,
      wrapper = arrow.closest('.FeaturedCollections__ProductsTabs')
    action === 'next'
      ? (wrapper.scrollLeft = wrapper.offsetWidth)
      : (wrapper.scrollLeft = 0)
  }
}

customElements.define('featured-collections', FeaturedCollections)

class MarketplaceCard extends HTMLElement {
  constructor() {
    super()
    this.form = this.querySelector('form')
    this.atc = this.querySelector('[data-marketplace-atc]')

    this.atc.addEventListener('click', (e) => this.marketplaceATC(e))
  }

  marketplaceATC(e) {
    e.preventDefault()
    const bodyObj = __THEME_GLOBALS__.serializeObject(this.form)
    __THEME_GLOBALS__.cart.cartEvent(
      '/cart/add.js',
      bodyObj,
      true,
      __THEME_GLOBALS__.pdpErrorMessage
    )
  }
}

customElements.define('marketplace-card', MarketplaceCard)

class SlideTabSection extends HTMLElement {
  constructor() {
    super()
    this.slider = this.querySelector('.jsSlickSlider')
    this.tabsSwitcher = this.querySelectorAll('.slide-tab__inner-switcher')
    this.tabs = this.querySelectorAll('.slide-tab__inner-tab')

    if (this.slider) {
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', (e) => {
          const slideSize = e.target.dataset.slideSize
          const slideIndex = e.target.dataset.slideIndex
          const switcherPosition =
            (100 / Number(slideSize)) * Number(slideIndex)
          $(this.slider).slick('slickGoTo', slideIndex)
          this.tabsSwitcher.forEach((switcher) => {
            switcher.style.left = `${switcherPosition}%`
          })
        })
      })
    }
  }
}

customElements.define('slide-tab-section', SlideTabSection)

class account extends HTMLElement {
  constructor() {
    super()
    this.breadcrumbs = this.querySelector('.breadcrumbs')
    this.dialog = this.querySelectorAll('[data-dialog]')
    this.toggleDialogBtn = this.querySelectorAll('[data-toggle-dialog]')
    this.inputs = this.querySelectorAll('.input-wrapper')
    this.checkbox = this.querySelectorAll('input[type=checkbox]')
    this.errorMeseges = this.querySelectorAll('.account-error')
    this.toglePassBtn = this.querySelectorAll('[data-togle-pass-visibility]')
    this.forms = this.querySelectorAll('form')
    this.registerForm = this.querySelector('#create_customer')
    if (this.registerForm)
      this.phoneInput = this.registerForm.querySelector(
        'input[name="customer[Phone]"]'
      )
    this.customerUpdateForm = this.querySelector('#form_update')
    this.customerUpdatePassForm = this.querySelector('#form_update-pass')
    this.customerContactPreferencesForm = this.querySelector(
      '#form_contact-preferences'
    )
    this.deleteAddressBtns = this.querySelectorAll('[data-delete-address]')
    this.toggleAddressBtns = this.querySelectorAll('[data-toggle-address]')
    this.accountPageContent = this.querySelector('[data-account-content]')
    this.sidebarAcoountOverview = this.querySelector('[data-account-overview]')

    this.eventListener()
  }

  eventListener() {
    this.toggleDialogBtn.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault()
        this.toggleDialog(btn)
      })
      if (btn.hasAttribute('data-click-trigger')) btn.click()
    })

    this.inputs.forEach((input) =>
      input.addEventListener('keyup', () => {
        this.removeErrorStatus(input)
      })
    )

    if (this.phoneInput) {
      this.phoneInput.addEventListener('change', () => {
        window.sessionStorage.setItem('Customer_phone', this.phoneInput.value)
      })
    }

    this.toglePassBtn.forEach((btn) =>
      btn.addEventListener('click', (e) => {
        e.preventDefault()
        this.togglePassVisibility(btn)
      })
    )

    this.checkbox.forEach((checkbox) =>
      checkbox.addEventListener('change', () => {
        this.toggleCheckboxState(checkbox)
      })
    )

    this.forms.forEach((form) => {
      form.addEventListener('submit', (e) => {
        e.preventDefault()
        const KlaviyoCheckboxes = form.querySelectorAll(
          'input[type=checkbox][data-klaviyo-list-id]'
        )
        const checked = Array.from(KlaviyoCheckboxes).map(
          (checkbox) => checkbox.value === 'true'
        )
        const emailInput = form.querySelector('input[type=email]')
        const passInput = form.querySelector('input[type=password]')
        const phoneInput = form.querySelector('input[type=tel]')

        // Empty email validation
        if (
          emailInput &&
          !this.emptyFieldValidation(
            emailInput,
            'Please enter an email address'
          )
        ) {
          return false
        }

        // Empty pass validation
        if (
          passInput &&
          !this.emptyFieldValidation(passInput, 'Please enter a password')
        ) {
          return false
        }

        // Phone validation
        if (phoneInput) {
          if (!this.phoneValidation(phoneInput)) {
            phoneInput.closest('.input-wrapper').classList.add('input-error')
            return false
          }
        }

        if (checked.length) {
          this.checkKlaviyoEvents(KlaviyoCheckboxes, form)
        } else {
          if (!form.hasAttribute('data-accenture-form')) form.submit()
        }
      })
    })

    this.deleteAddressBtns.forEach((btn) =>
      btn.addEventListener('click', (e) => {
        e.preventDefault()
        const addressID = btn.getAttribute('data-delete-address')
        this.removeAddress(addressID)
      })
    )

    this.toggleAddressBtns.forEach((btn) =>
      btn.addEventListener('click', (e) => {
        e.preventDefault()
        const id = btn.getAttribute('data-toggle-address')
        const title = btn.getAttribute('data-breadcrumbs-title')
        this.toggleAddress(id, title)
      })
    )

    if (this.customerUpdateForm)
      this.accentureEventListener(this.customerUpdateForm)
    if (this.customerUpdatePassForm)
      this.accentureEventListener(this.customerUpdatePassForm)
    if (this.customerContactPreferencesForm)
      this.accentureEventListener(this.customerContactPreferencesForm)

    if (window.location.hash === '#recover') {
      setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 0)
    }
  }

  accentureEventListener(form) {
    const _self = this
    const submitBtn = form.querySelector('button[type=submit]')
    const errorsContainer = form.querySelector('.account-error')
    const errorsInner = form.querySelector('.account-error-inner')
    const allInputs = form.querySelectorAll('input')
    const phoneInput = form.querySelector('input[type=tel]')

    form.addEventListener('submit', (e) => e.preventDefault())

    Accentuate(jQuery('#' + form.id), function (data) {
      if (phoneInput) {
        if (!_self.phoneValidation(phoneInput)) {
          phoneInput.closest('.input-wrapper').classList.add('input-error')
          return false
        }
      }

      if (data.errors !== undefined) {
        submitBtn.disabled = true

        if (
          data.errors.email !== undefined &&
          data.errors.email[0] === 'is invalid'
        ) {
          const message = 'Please enter a valid email address.'
          if (errorsInner) errorsInner.innerHTML += message
          if (errorsContainer) errorsContainer.classList.remove('is-hidden')
        } else if (
          data.errors.email !== undefined &&
          data.errors.email[0] === 'already has an account'
        ) {
          const message = 'This email is already associated with an account'
          if (errorsInner) errorsInner.innerHTML += message
          if (errorsContainer) errorsContainer.classList.remove('is-hidden')
        } else if (
          data.errors.phone !== undefined &&
          data.errors.phone[0] === 'Phone has already been taken'
        ) {
          const message = 'Phone has already been taken'
          if (errorsInner) errorsInner.innerHTML += message
          if (errorsContainer) errorsContainer.classList.remove('is-hidden')
          phoneInput.closest('.input-wrapper').classList.add('input-error')
        } else if (
          data.errors.phone !== undefined &&
          data.errors.phone[0] ===
            'Enter a valid phone number to use this delivery method'
        ) {
          const message = 'Please enter a valid phone number'
          if (errorsInner) errorsInner.innerHTML += message
          if (errorsContainer) errorsContainer.classList.remove('is-hidden')
          phoneInput.closest('.input-wrapper').classList.add('input-error')
        } else if (
          data.errors.email !== undefined &&
          data.errors.email[0] === 'contains an invalid domain name'
        ) {
          const message = 'Please enter a valid email address.'
          if (errorsInner) errorsInner.innerHTML += message
          if (errorsContainer) errorsContainer.classList.remove('is-hidden')
        } else if (
          data.errors.password !== undefined &&
          data.errors.password[0] === 'is too short (minimum is 5 characters)'
        ) {
          const message = 'Your password must be at least 5 characters long'
          if (errorsInner) errorsInner.innerHTML += message
          if (errorsContainer) errorsContainer.classList.remove('is-hidden')
        } else if (
          data.errors.password_confirmation !== undefined &&
          data.errors.password_confirmation[0] ===
            'must match the provided password'
        ) {
          const message = 'Password and confirmation password do not match'
          if (errorsInner) errorsInner.innerHTML += message
          if (errorsContainer) errorsContainer.classList.remove('is-hidden')
        }
      } else if (data.status === 'OK') {
        location.reload()
      }
    })

    allInputs.forEach((input) =>
      input.addEventListener('keyup', () => {
        if (errorsContainer) {
          if (!errorsContainer.classList.contains('is-hidden'))
            errorsContainer.classList.add('is-hidden')
        }
        if (submitBtn.disabled) submitBtn.removeAttribute('disabled')
      })
    )
  }

  phoneValidation(phoneInput) {
    const phoneValue = phoneInput.value
    const re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im
    return phoneValue === '' ? true : re.test(phoneValue)
  }

  emptyFieldValidation(input, errorMessage) {
    const inputValue = input.value
    let valid = true
    if (inputValue === null || inputValue === '') {
      const inputWrapper = input.closest('.input-wrapper')
      inputWrapper.classList.add('input-error')
      if (errorMessage) {
        inputWrapper.querySelector('.input-wrapper__error').innerHTML =
          errorMessage
      }
      valid = false
    }
    return valid
  }

  checkKlaviyoEvents(KlaviyoCheckboxes, form) {
    Promise.all(
      Array.from(KlaviyoCheckboxes).map((checkbox) => {
        const listID = checkbox.dataset.klaviyoListId || null
        if (checkbox.checked && listID)
          return __THEME_GLOBALS__.klaviyoTrigger(form, listID)
      })
    ).then(() => {
      form.submit()
    })
  }

  toggleDialog(btn) {
    this.dialog.forEach((dialog) => {
      dialog.id === btn.dataset.toggleDialog
        ? (dialog.style.display = 'flex')
        : (dialog.style.display = 'none')
    })
  }

  removeErrorStatus(input) {
    if (input.classList.contains('input-error')) {
      this.inputs.forEach((input) => input.classList.remove('input-error'))
      this.errorMeseges.forEach((error) => {
        if (error.querySelector('.account-error-inner'))
          error.querySelector('.account-error-inner').innerHTML = ''
        error.classList.add('is-hidden')
      })
    }
  }

  togglePassVisibility(btn) {
    const input = btn.parentElement.querySelector('input')
    btn.classList.toggle('show')
    if (btn.classList.contains('show')) {
      input.type = 'text'
      btn.innerHTML = 'Hide'
    } else {
      input.type = 'password'
      btn.innerHTML = 'Show'
    }
  }

  toggleCheckboxState(checkbox) {
    checkbox.checked ? (checkbox.value = 'true') : (checkbox.value = 'false')
  }

  removeAddress(id) {
    if (!id) return
    const form = document.createElement('form')
    const input = document.createElement('input')

    form.setAttribute('method', 'post')
    form.setAttribute('action', '/account/addresses/' + id)

    input.setAttribute('type', 'hidden')
    input.setAttribute('name', '_method')
    input.setAttribute('value', 'delete')

    form.appendChild(input)

    document.body.appendChild(form)
    form.submit()
    document.body.removeChild(form)
  }

  toggleAddress(id, title) {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })

    const form = document.getElementById('form_' + id)
    form.style.display = form.style.display === 'none' ? '' : 'none'
    this.accountPageContent.style.display =
      this.accountPageContent.style.display === 'none' ? '' : 'none'
    this.sidebarAcoountOverview.classList.toggle('current-page')

    if (title) {
      const hasBreadcrumbs = this.breadcrumbs.querySelector(
        '[data-breadcrumbs-title="' + title + '"]'
      )
      const breadcrumbsChild = `<li data-breadcrumbs-title="${title}">${title}</li>`
      !hasBreadcrumbs
        ? (this.breadcrumbs.querySelector('ol').innerHTML += breadcrumbsChild)
        : hasBreadcrumbs.remove()
    }
  }
}

customElements.define('account-element', account)

let govaloPdpModal = {
  designApplied: false,
  capitalize: (str) => {
    return str && str[0].toUpperCase() + str.slice(1)
  },
  toggleRoastOption: () => {
    let planValue = $('#gvloModal #option0').val()
    if (planValue === 'Premium') {
      $('#gvloModal #option1').parent('.gvlo-amount').addClass('hidden')
      $('#gvloModal .gvlo-form ').addClass('gvlo-premium-selected')
    } else {
      $('#gvloModal #option1').parent('.gvlo-amount').removeClass('hidden')
      $('#gvloModal .gvlo-form ').removeClass('gvlo-premium-selected')
    }
  },
  trapFocus: () => {
    let gvloModal = $('#gvloModal')
    let firstFocusableEl = gvloModal.find('select#option0')[0]
    firstFocusableEl.focus()

    gvloModal[0].addEventListener('keydown', function (e) {
      let isTabPressed = e.key === 'Tab'
      let lastFocusableEl = gvloModal.find("[id='Gift Note']")[0]

      if (!gvloModal.find('.gvlo-button').prop('disabled')) {
        lastFocusableEl = gvloModal.find('.gvlo-button')[0]
      }

      if (!isTabPressed) {
        return
      }

      if (e.shiftKey) {
        if (document.activeElement === firstFocusableEl) {
          lastFocusableEl.focus()
          e.preventDefault()
        }
      } else {
        if (document.activeElement === lastFocusableEl) {
          firstFocusableEl.focus()
          e.preventDefault()
        }
      }
    })
  },
  syncProductQuantity: () => {
    $('#productQuantity').val($('#gvlo-product-quantity').val())
  },
  updateDesign: () => {
    let gvloModal = $('#gvloModal')
    let quantity = $('<div>', {
      class: 'gvlo-field gvlo-quantity gvlo-amount svelte-12xebdh',
    })
    let shippedEvery = $('<div>', {
      class: 'gvlo-field gvlo-shipped-every gvlo-amount svelte-12xebdh',
    })
    let quantityStepper = $('#productQuantity')
      .parents('quantity-stepper')
      .clone()
    let shippedEverySelect = $('[name=selling_plan]').clone()

    quantityStepper
      .find('input')
      .attr('id', 'gvlo-product-quantity')
      .attr('disabled', true)
    quantity.append(
      '<label for="gvlo-product-quantity">Bags per Shipment:</label>'
    )
    quantity.append(quantityStepper)

    shippedEverySelect
      .attr('id', 'gvlo-shipped-every')
      .addClass('subscription__select')
    shippedEvery.append(
      '<label for="gvlo-shipped-every">Shipped Every:</label>'
    )
    shippedEvery.append(shippedEverySelect)

    gvloModal.find(`#option0`).addClass('subscription__select')
    gvloModal.find(`#option1`).addClass('subscription__select')
    gvloModal.find(`#option2`).addClass('subscription__select')

    gvloModal.find(`#option0 option`).each(function () {
      if ($(this).val().toLowerCase().includes('(gift)')) $(this).hide()
    })

    gvloModal.find('.gvlo-heading').html('Plan Details')
    gvloModal.find("label[for='Option 1']").html('Plan:')
    gvloModal.find("label[for='Option 2']").html('Roast:')
    gvloModal.find('#option2').parents('.gvlo-field').before(shippedEvery)
    gvloModal.find('.gvlo-recipient-name').before(quantity)
    gvloModal
      .find('.gvlo-recipient-name')
      .before(
        '<h2 class="gvlo-heading gvlo-receipent-info">Recipient Information</h2>'
      )
    gvloModal
      .find('.gvlo-recipient-name')
      .before(
        '<p class="gvlo-field gvlo-us-only-notice">Please note: your recipient must have a U.S. shipping address to use their subscription</p>'
      )
    gvloModal
      .find('.gvlo-recipient-name input')
      .attr('placeholder', "Enter Recipient's Name")
    gvloModal
      .find('.gvlo-recipient-email input')
      .attr('placeholder', "Enter Recipient's Email")
    gvloModal.find('#option0').on('change', govaloPdpModal.toggleRoastOption)
    $('#gvloModal').on(
      'change',
      '#gvlo-product-quantity',
      govaloPdpModal.syncProductQuantity
    )
    $('#gvloModal').on(
      'click',
      '.cart-stepper',
      govaloPdpModal.syncProductQuantity
    )
    govaloPdpModal.validate()
  },
  updateData: () => {
    let selectedPlan = $('input[name="Plan"]:checked').val()
    let selectedRoast = $('input[name="Roast"]:checked').val()
    let gvloModal = $('#gvloModal')

    gvloModal.find(`#option0`).val(govaloPdpModal.capitalize(selectedPlan))
    gvloModal.find(`#option1`).val(govaloPdpModal.capitalize(selectedRoast))
    govaloPdpModal.toggleRoastOption()

    gvloModal.find('#gvlo-shipped-every').val($('[name=selling_plan]').val())
    const optionSelected = gvloModal.find('[name=selling_plan]')[0]
    const planSelected =
      optionSelected.options[optionSelected.selectedIndex].dataset.planOption
    gvloModal
      .find('form')
      .append(
        '<input name="ships" type="hidden" value="' +
          planSelected +
          '" class="js-set-x">'
      )
    gvloModal.find('#gvlo-shipped-every').on('change', () => {
      $('[name=selling_plan]').val(gvloModal.find('#gvlo-shipped-every').val())

      const optionSelected = $('[name=selling_plan]')[0]
      const planSelected =
        optionSelected.options[optionSelected.selectedIndex].dataset.planOption
      $('[name="ships"]').val(planSelected)
    })
    gvloModal.find('#option2').val($('#shipment_number_copy').val())
    gvloModal.find('#gvlo-product-quantity').val($('#productQuantity').val())
  },
  resetErrors: (target) => {
    target.siblings('span.error').remove()
    target.removeClass('error')
  },
  validateInputs: (e) => {
    let gvloModal = $('#gvloModal')
    let receipentName = gvloModal.find("[id='Recipient Name']")
    let receipentEmail = gvloModal.find("[id='Recipient Email']")

    let currentTarget = $(e.currentTarget)

    govaloPdpModal.resetErrors(currentTarget)

    if (currentTarget.attr('type') === 'email') {
      let emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/

      if (!currentTarget.val() || !emailReg.test(currentTarget.val())) {
        currentTarget.addClass('error')
        currentTarget.after(
          '<span class="error">Please enter a valid email</span>'
        )
        gvloModal.find('.cart__button').attr('disabled', true)
      }
    } else {
      if (!currentTarget.val()) {
        currentTarget.addClass('error')
        currentTarget.after('<span class="error">This field is required</span>')
        gvloModal.find('.cart__button').attr('disabled', true)
      }
    }

    if (
      receipentEmail.val() &&
      receipentName.val() &&
      !receipentEmail.hasClass('error') &&
      !receipentName.hasClass('error')
    ) {
      gvloModal.find('.cart__button').attr('disabled', false)
    }
  },
  validate: () => {
    let gvloModal = $('#gvloModal')
    let receipentName = gvloModal.find("[id='Recipient Name']")
    let receipentEmail = gvloModal.find("[id='Recipient Email']")
    gvloModal.find('.cart__button').attr('disabled', true)

    receipentName.on('blur input', govaloPdpModal.validateInputs)
    receipentEmail.on('blur input', govaloPdpModal.validateInputs)
  },
  resetFields: () => {
    const modal = document.getElementById('gvloModal')
    if (!modal) return

    const fields = [
      ...modal.querySelectorAll(
        'input[type="text"]:not(#datePicker),input[type="email"],textarea'
      ),
    ]
    fields.forEach((field) => {
      field.value = ''
      field.classList.remove('error')
      field.nextElementSibling?.remove()
    })
  },
  init: () => {
    if (!govaloPdpModal.designApplied) {
      govaloPdpModal.updateDesign()
      govaloPdpModal.designApplied = true
    }

    govaloPdpModal.updateData()
  },
}

$('body').on('click', '#gvloApp', () => {
  if ($('#gvloModal').hasClass('gvlo-hidden')) {
    $('body').css('overflow', '')
  }
})

window.addEventListener('govalo:toggleModal', async (e) => {
  govaloPdpModal.resetFields()

  // A change event needs fired on Govalo fields so they recogonize this change
  setTimeout(() => {
    ;['option0', 'option1', 'option2'].forEach((el) => {
      const element = document.getElementById(el)
      const event = new Event('change')
      element.dispatchEvent(event)
    })
  }, 500)
})

window.addEventListener('govalo:productAddedToCart', async (e) => {
  if (!theme) return
  const raw = await fetch('/cart?section_id=cart-drawer-content', {
    headers: { 'Content-Type': 'application/json' },
  })
  const html = await raw.text()

  const parser = new DOMParser()
  const el = parser.parseFromString(html, 'text/html')

  __THEME_GLOBALS__.cart.renderContent(el, 'cart-drawer-content')
  __THEME_GLOBALS__.cart.openDrawer()
})

$('html').on('keydown', function (e) {
  const tagName = (e.target?.tagName || '').toLowerCase()
  if (
    e.keyCode === 32 &&
    !['input', 'select', 'textarea', 'button'].includes(tagName)
  )
    e.preventDefault()
})

$('html').on('keyup', function (e) {
  if (e.target.control && e.keyCode === 32) {
    if (e.target.control.closest('.radio-group'))
      e.target.control
        .closest('.radio-group')
        .querySelector('[type="radio"]').checked = false

    if (e.target.control.getAttribute('type') === 'checkbox') {
      e.target.control.checked = !e.target.control.checked
    } else {
      e.target.control.checked = true
    }

    e.target.control.dispatchEvent(new Event('change'))
    e.target.form.dispatchEvent(new Event('change'))
  }

  if (e.keyCode === 32 && e.target.getAttribute('role') === 'button') {
    e.target.click()
  }
})

if (document.querySelector('.sellers-distributors')) {
  const zones = document.querySelectorAll('.js-accordion-toggle')
  zones?.forEach((el) => {
    el.addEventListener('click', ({ target }) => {
      target.nextElementSibling?.classList?.toggle('active')
    })
  })
}

// PDP featured categories
document.addEventListener('click', (e) => {
  if (!e.target.closest('.featured-category-tab')) return

  e.preventDefault()

  const { tabIndex } = e.target.closest('.featured-category-tab').dataset

  Array.from(document.querySelectorAll('.featured-category-tab')).map((tab) =>
    tab.classList.remove('active')
  )
  Array.from(document.querySelectorAll('.featured-category__tab-content')).map(
    (tab) => tab.classList.remove('active')
  )

  document
    .querySelector(
      `.featured-category__tab-content[data-content-index="${tabIndex}"]`
    )
    .classList.add('active')
  document
    .querySelector(`.featured-category-tab[data-tab-index="${tabIndex}"]`)
    .classList.add('active')
})

class ProductKeyFeatures extends HTMLElement {
  constructor() {
    super()

    this.slider = this.querySelector('.js-image-slider')
    window.addEventListener('resize', () => {
      $(this.slider).slick('setPosition')
    })

    this.querySelectorAll('.js-key-feature-title')?.forEach((slide) => {
      slide.addEventListener('click', (e) => {
        const { index } = e.target.dataset
        this.querySelectorAll('.js-key-feature-title')?.forEach((item) =>
          item.classList.remove('active')
        )

        e.target.classList.add('active')
        $(this.slider).slick('slickGoTo', index)
      })
    })

    this.querySelectorAll('[data-slide-toggle]')?.forEach((accordion) => {
      accordion.addEventListener('click', (e) => {
        e.preventDefault()
        const elem = e.target.closest('[data-slide-toggle]')
        const { index } = elem.dataset

        $(this.slider).slick('slickGoTo', index)

        this.querySelectorAll('[data-slide-toggle]')?.forEach((slide) => {
          const target = this.querySelector(
            `[data-slide-target="${slide.dataset.slideToggle}"]`
          )
          if (!slide.isSameNode(elem) && target?.classList.contains('active')) {
            target.classList.remove('active')
            __THEME_GLOBALS__.slideUp(target)
          }
        })
      })
    })
  }

  connectedCallback() {
    $(this.slider).slick({
      adaptiveHeight: true,
      arrows: false,
      dots: true,
      infinite: true,
    })

    $(this.slider).on(
      'afterChange',
      (event, slick, currentSlide, nextSlide) => {
        this.querySelectorAll('.js-key-feature-title')?.forEach((item) =>
          item.classList.remove('active')
        )
        this.querySelector(
          `.js-key-feature-title[data-index="${currentSlide}"]`
        ).classList.add('active')

        if (
          !this.querySelector(
            `[data-slide-toggle][data-index="${currentSlide}"]`
          ).classList.contains('active')
        ) {
          this.querySelector(
            `[data-slide-toggle][data-index="${currentSlide}"]`
          ).click()
        }
      }
    )
  }
}

customElements.define('product-key-features', ProductKeyFeatures)

class pdpLineItemsChart extends HTMLElement {
  constructor() {
    super()

    this.product = window.__THEME_GLOBALS__.product
    this.variants = this.product.variants
    this.atcButton = this.querySelector('.js-submit')
    this.payload = {}
  }

  connectedCallback() {
    Array.from(this.querySelectorAll('.js-quantity')).map((input) => {
      input.addEventListener('change', () => {
        const row = input.closest('tr')
        const variantId = row.dataset.id

        this.payload[variantId] = parseInt(input.value)

        this.refreshLineItemsChart()
      })
    })

    this.atcButton.addEventListener('click', () => {
      this.addItemsToCart()
    })
  }

  refreshLineItemsChart() {
    let totalPrice = 0

    Object.keys(this.payload).map((variantId) => {
      const quantity = this.payload[variantId]

      const variant = this.variants.find((e) => +e.id === +variantId)
      const linePrice = variant.price * quantity
      totalPrice += linePrice

      this.querySelectorAll(
        `.pdp-line-item[data-id="${variantId}"] .js-line-price-total`
      )?.forEach((pricing) => {
        pricing.innerHTML = __THEME_GLOBALS__.formatMoney(
          linePrice,
          '${{amount}}'
        )
      })
    })

    this.querySelector('.js-subtotal').innerHTML =
      __THEME_GLOBALS__.formatMoney(totalPrice, '${{amount}}')

    const totalQty = Object.keys(this.payload)
      .map((id) => parseInt(this.payload[id]))
      .reduce((a, b) => a + b, 0)

    if (totalQty > 0) {
      this.atcButton.removeAttribute('disabled')
    } else {
      this.atcButton.setAttribute('disabled', true)
    }
  }

  addItemsToCart() {
    const items = Object.keys(this.payload)
      .map((id) => ({
        id,
        quantity: parseInt(this.payload[id]),
      }))
      .filter((item) => item.quantity > 0)

    __THEME_GLOBALS__.cart.cartEvent(
      '/cart/add.js',
      { items },
      true,
      __THEME_GLOBALS__.pdpErrorMessage
    )
  }
}

customElements.define('pdp-line-items-chart', pdpLineItemsChart)

class StickyCTA extends HTMLElement {
  constructor() {
    super()

    this.optionsEl?.addEventListener(
      'change',
      this.onStickyOptionChange.bind(this)
    )
    this.stickyNavLinks.forEach((link) => {
      link.addEventListener('click', this.onClickLink.bind(this))
    })
  }

  onClickLink(event) {
    const targetSelector = event.currentTarget.getAttribute('href')
    const targetEl = document.querySelector(targetSelector)
    if (targetEl) {
      event.preventDefault()
      window.scrollTo({
        top: this.getElementTop(targetEl),
        behavior: 'smooth',
      })
    }
  }

  getElementTop(elementEl) {
    const { top } = elementEl.getBoundingClientRect()
    const headerHeight = parseInt(
      document.querySelector(':root').style.getPropertyValue('--header-height')
    )
    const stickyHeight = parseInt(
      document
        .querySelector(':root')
        .style.getPropertyValue('--custom-main-offset')
    )
    const hideHeader = document.body.classList.contains('hide-header')
    let targetTop = hideHeader
      ? top - stickyHeight
      : top - stickyHeight - headerHeight
    return top + window.scrollY - stickyHeight - headerHeight
  }

  onStickyOptionChange(event) {
    const { name = '', valueHandle = '' } = event.target.dataset

    if (name && valueHandle) this.selectValue(name, valueHandle)
  }

  selectValue(name, valueHandle) {
    const selector = `.radio-group input[type="radio"][data-name="${name}"][data-value-handle="${valueHandle}"]`
    document.querySelectorAll(selector).forEach((targetInput) => {
      if (!targetInput.checked) {
        const group = targetInput.closest('.radio-group')
        group.querySelectorAll('input[type="radio"]').forEach((input) => {
          if (input == targetInput) {
            input.checked = true
          } else {
            input.checked = false
          }
        })
        targetInput.closest('form')?.dispatchEvent(new Event('change'))
      }
    })
  }

  get optionsEl() {
    return this.querySelector('.js-sticky-options')
  }

  get stickyNavLinks() {
    return this.querySelectorAll('.js-sticky-nav-link')
  }
}
customElements.define('sticky-cta', StickyCTA)
